(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[522],{

/***/ 1239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Icon; }
});

;// CONCATENATED MODULE: ./node_modules/@carbon/icon-helpers/es/index.js
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

var _excluded = ["width", "height", "viewBox"],
  _excluded2 = ["tabindex"];
/**
 * Copyright IBM Corp. 2018, 2026
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  // Reference:
  // https://github.com/IBM/carbon-components-react/issues/1392
  // https://github.com/PolymerElements/iron-iconset-svg/pull/47
  // `focusable` is a string attribute which is why we do not use a boolean here
  focusable: 'false',
  preserveAspectRatio: 'xMidYMid meet'
};

/**
 * Get supplementary HTML attributes for a given <svg> element based on existing
 * attributes.
 */
function getAttributes() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    width = _ref.width,
    height = _ref.height,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? "0 0 ".concat(width, " ").concat(height) : _ref$viewBox,
    attributes = _objectWithoutProperties(_ref, _excluded);
  var tabindex = attributes.tabindex,
    rest = _objectWithoutProperties(attributes, _excluded2);
  var iconAttributes = _objectSpread2(_objectSpread2(_objectSpread2({}, defaultAttributes), rest), {}, {
    width: width,
    height: height,
    viewBox: viewBox
  });
  if (iconAttributes['aria-label'] || iconAttributes['aria-labelledby']) {
    iconAttributes.role = 'img';

    // Reference:
    // https://allyjs.io/tutorials/focusing-in-svg.html
    if (tabindex !== undefined && tabindex !== null) {
      iconAttributes.focusable = 'true';
      iconAttributes.tabindex = tabindex;
    }
  } else {
    iconAttributes['aria-hidden'] = true;
  }
  return iconAttributes;
}

/**
 * Copyright IBM Corp. 2018, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Convert an icon descriptor to a String
 */
function es_toString(descriptor) {
  var _descriptor$elem = descriptor.elem,
    elem = _descriptor$elem === void 0 ? 'svg' : _descriptor$elem,
    _descriptor$attrs = descriptor.attrs,
    attrs = _descriptor$attrs === void 0 ? {} : _descriptor$attrs,
    _descriptor$content = descriptor.content,
    content = _descriptor$content === void 0 ? [] : _descriptor$content;
  var children = content.map(es_toString).join('');
  if (elem !== 'svg') {
    return "<".concat(elem, " ").concat(formatAttributes(attrs), ">").concat(children, "</").concat(elem, ">");
  }
  return "<".concat(elem, " ").concat(formatAttributes(getAttributes(attrs)), ">").concat(children, "</").concat(elem, ">");
}
function formatAttributes(attrs) {
  return Object.keys(attrs).reduce(function (acc, key, index) {
    var attribute = "".concat(key, "=\"").concat(attrs[key], "\"");
    if (index === 0) {
      return attribute;
    }
    return acc + ' ' + attribute;
  }, '');
}

/**
 * Copyright IBM Corp. 2018, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Convert an icon descriptor to a DOM node.
 */
function toSVG(descriptor) {
  var _descriptor$elem = descriptor.elem,
    elem = _descriptor$elem === void 0 ? 'svg' : _descriptor$elem,
    _descriptor$attrs = descriptor.attrs,
    attrs = _descriptor$attrs === void 0 ? {} : _descriptor$attrs,
    _descriptor$content = descriptor.content,
    content = _descriptor$content === void 0 ? [] : _descriptor$content;
  var node = document.createElementNS('http://www.w3.org/2000/svg', elem);
  var attributes = elem !== 'svg' ? attrs : getAttributes(attrs);
  Object.keys(attributes).forEach(function (key) {
    node.setAttribute(key, attrs[key]);
  });
  for (var i = 0; i < content.length; i++) {
    node.appendChild(toSVG(content[i]));
  }
  return node;
}



// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@carbon/icons-react/es/Icon.js
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */




/**
 * Copyright IBM Corp. 2019, 2026
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
const Icon = /*#__PURE__*/(0,react.forwardRef)(function Icon({
  className,
  children,
  tabIndex,
  xmlns = 'http://www.w3.org/2000/svg',
  preserveAspectRatio = 'xMidYMid meet',
  ...rest
}, ref) {
  const {
    tabindex,
    ...attrs
  } = getAttributes({
    ...rest,
    tabindex: tabIndex
  });
  const props = attrs;
  if (className) {
    props.className = className;
  }
  if (tabindex !== undefined && tabindex !== null) {
    if (typeof tabindex === 'number') {
      props.tabIndex = tabindex;
    } else {
      props.tabIndex = Number(tabIndex);
    }
  }
  if (ref) {
    props.ref = ref;
  }
  if (xmlns) {
    props.xmlns = xmlns;
  }
  if (preserveAspectRatio) {
    props.preserveAspectRatio = preserveAspectRatio;
  }
  return /*#__PURE__*/react.createElement('svg', props, children);
});
Icon.displayName = 'Icon';
Icon.propTypes = {
  'aria-hidden': prop_types_default().oneOfType([(prop_types_default()).bool, prop_types_default().oneOf(['true', 'false'])]),
  'aria-label': (prop_types_default()).string,
  'aria-labelledby': (prop_types_default()).string,
  children: (prop_types_default()).node,
  className: (prop_types_default()).string,
  height: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  preserveAspectRatio: (prop_types_default()).string,
  tabIndex: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  viewBox: (prop_types_default()).string,
  width: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  xmlns: (prop_types_default()).string
};




/***/ }),

/***/ 6817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nq": function() { return /* binding */ LogoDiscord; }
/* harmony export */ });
/* unused harmony exports LayersExternal, Legend, LetterAa, LetterBb, LetterCc, LetterDd, LetterEe, LetterFf, LetterGg, LetterHh, LetterIi, LetterJj, LetterKk, LetterLl, LetterMm, LetterNn, LetterOo, LetterPp, LetterQq, LetterRr, LetterSs, LetterTt, LetterUu, LetterVv, LetterWw, LetterXx, LetterYy, LetterZz, License, LicenseDraft, LicenseGlobal, LicenseMaintenance, LicenseMaintenanceDraft, LicenseThirdParty, LicenseThirdPartyDraft, Lifesaver, Light, LightFilled, Lightning, LineThick, LineThin, Link, Linux, LinuxAlt, LinuxNamespace, List, ListBoxes, ListBulleted, ListChecked, ListCheckedMirror, ListDropdown, ListNumbered, ListNumberedMirror, ListTree, LoadBalancerApplication, LoadBalancerClassic, LoadBalancerGlobal, LoadBalancerListener, LoadBalancerLocal, LoadBalancerNetwork, LoadBalancerPool, LoadBalancerVpc, Location, LocationCompany, LocationCompanyFilled, LocationCurrent, LocationFilled, LocationHazard, LocationHazardFilled, LocationHeart, LocationHeartFilled, LocationInfo, LocationInfoFilled, LocationPerson, LocationPersonFilled, LocationSave, LocationStar, LocationStarFilled, Locked, LockedAndBlocked, LogicalPartition, Login, LogoAngular, LogoAnsibleCommunity, LogoBluesky, LogoDigg, LogoFacebook, LogoFigma, LogoFlickr, LogoGit, LogoGithub, LogoGitlab, LogoGlassdoor, LogoInstagram, LogoInvision, LogoJupyter, LogoKeybase, LogoKubernetes, LogoLinkedin, LogoLivestream, LogoMastodon, LogoMedium, LogoModelContextProtocol, LogoNpm, LogoOpenshift, LogoPinterest, LogoPython, LogoQuora, LogoRScript, LogoReact, LogoRedHatAiInstructlabOnIbmCloud, LogoRedHatAnsible, LogoSketch, LogoSkype, LogoSlack, LogoSnapchat, LogoSvelte, LogoTumblr, LogoTwitter, LogoVmware, LogoVmwareAlt, LogoVue, LogoWechat, LogoX */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1239);
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */






var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _circle, _circle2, _path145, _path146, _circle3, _circle4, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _circle5, _circle6, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _circle7, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _circle8, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _circle9, _circle0, _path268, _path269, _path270, _path271, _path272, _circle1, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337;
const LayersExternal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LayersExternal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,24c-.1631,0-.3262-.0398-.4741-.1196l-13-7,.9482-1.7607,12.5259,6.7446,12.5259-6.7446.9482,1.7607-13,7c-.1479.0798-.311.1196-.4741.1196Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30c-.1631,0-.3262-.0398-.4741-.1196l-13-7,.9482-1.7607,12.5259,6.7446,12.5259-6.7446.9482,1.7607-13,7c-.1479.0798-.311.1196-.4741.1196Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.4741,9.1196L16,1.8643v2.2715l10.8906,5.8643-10.8906,5.8643v2.2715l13.4741-7.2554c.324-.1743.5259-.5122.5259-.8804s-.2019-.7061-.5259-.8804Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4.4141,9.4141l3.5859-3.586v8.1719s2,0,2,0V5.8281s3.5859,3.5859,3.5859,3.5859l1.4141-1.414L9,2,3,8l1.4141,1.4141Z"
  })), children);
})));
if (false) {}
const Legend = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Legend({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "6",
    height: "6",
    x: "4",
    y: "20",
    rx: "1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12h-5a.5.5,0,0,1-.4473-.7236l2.5-5.0224a.5206.5206,0,0,1,.8945,0l2.5,5.0225A.5.5,0,0,1,9.5,12Z"
  })), children);
})));
if (false) {}
const LetterAa = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterAa({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13H18v2h5v2H19a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V15A2,2,0,0,0,23,13Zm0,8H19V19h4Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13,9H9a2,2,0,0,0-2,2V23H9V18h4v5h2V11A2,2,0,0,0,13,9ZM9,16V11h4v5Z"
  })), children);
})));
if (false) {}
const LetterBb = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterBb({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13H19V9H17V23h6a2,2,0,0,0,2-2V15A2,2,0,0,0,23,13Zm-4,8V15h4v6Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15,12a3,3,0,0,0-3-3H7V23h5a3,3,0,0,0,3-3V18a3,3,0,0,0-.78-2A3,3,0,0,0,15,14ZM9,11h3a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H9Zm4,9a1,1,0,0,1-1,1H9V17h3a1,1,0,0,1,1,1Z"
  })), children);
})));
if (false) {}
const LetterCc = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterCc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24,23H19a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H19v6h5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9V21h6Z"
  })), children);
})));
if (false) {}
const LetterDd = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterDd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23,9v4H19a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6V9Zm-4,6h4v6H19Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11,23H7V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,11,23ZM9,21h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H9Z"
  })), children);
})));
if (false) {}
const LetterEe = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterEe({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25,19V15a2.0023,2.0023,0,0,0-2-2H19a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V21H19V19Zm-6-4h4v2H19Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11 15 9 7 9 7 23 15 23 15 21 9 21 9 17 14 17 14 15 9 15 9 11 15 11z"
  })), children);
})));
if (false) {}
const LetterFf = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterFf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11 16 9 8 9 8 23 10 23 10 17 15 17 15 15 10 15 10 11 16 11z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24,11V9H21a2,2,0,0,0-2,2v2H17v2h2v8h2V15h3V13H21V11Z"
  })), children);
})));
if (false) {}
const LetterGg = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterGg({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19,13a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h4v2H18v2h5a2,2,0,0,0,2-2V13Zm4,8H19V15h4Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9V21h4V17H11V15h4Z"
  })), children);
})));
if (false) {}
const LetterHh = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterHh({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9 13 15 9 15 9 9 7 9 7 23 9 23 9 17 13 17 13 23 15 23 15 9 13 9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13H19V9H17V23h2V15h4v8h2V15A2,2,0,0,0,23,13Z"
  })), children);
})));
if (false) {}
const LetterIi = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterIi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11 13 11 13 21 10 21 10 23 18 23 18 21 15 21 15 11 18 11 18 9 10 9 10 11z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13H22V23H20z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9H22V11H20z"
  })), children);
})));
if (false) {}
const LetterJj = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterJj({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9H22V11H20z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20,25H17v2h3a2,2,0,0,0,2-2V13H20Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H10a2,2,0,0,1-2-2V19h2v2h4V9h2V21A2,2,0,0,1,14,23Z"
  })), children);
})));
if (false) {}
const LetterKk = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterKk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9 12.89 9 9 15.55 9 9 7 9 7 23 9 23 9 18.71 9.93 17.22 12.89 23 15 23 11.11 15.43 15 9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.78 23 25 23 21.22 17 25 13 22.76 13 19 17.17 19 9 17 9 17 23 19 23 19 19.25 19.96 18.21 22.78 23z"
  })), children);
})));
if (false) {}
const LetterLl = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterLl({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21 11 9 9 9 9 23 17 23 17 21 11 21z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23H21a2,2,0,0,1-2-2V9h2V21h2Z"
  })), children);
})));
if (false) {}
const LetterMm = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterMm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13H16V23h2V15h2v8h2V15h2v8h2V15A2,2,0,0,0,24,13Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9 10.48 14 10 15.98 9.54 14 8 9 6 9 6 23 8 23 8 15 7.84 13 8.42 15 10 19.63 11.58 15 12.16 13 12 15 12 23 14 23 14 9 12 9z"
  })), children);
})));
if (false) {}
const LetterNn = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterNn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H23V15H19v8H17V13h6a2,2,0,0,1,2,2Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19 9.32 9 7 9 7 23 9 23 9 13 12.68 23 15 23 15 9 13 9 13 19z"
  })), children);
})));
if (false) {}
const LetterOo = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterOo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23H19a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v6A2,2,0,0,1,23,23Zm-4-8v6h4V15Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h4a2,2,0,0,1,2,2V21A2,2,0,0,1,13,23ZM9,11V21h4V11Z"
  })), children);
})));
if (false) {}
const LetterPp = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterPp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13H17V27h2V23h4a2,2,0,0,0,2-2V15A2,2,0,0,0,23,13Zm-4,8V15h4v6Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9,23H7V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H9Zm0-7h4V11H9Z"
  })), children);
})));
if (false) {}
const LetterQq = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterQq({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19,13a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h4v4h2V13Zm4,8H19V15h4Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13,9H9a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h1v2a2,2,0,0,0,2,2h2V25H12V23h1a2,2,0,0,0,2-2V11A2,2,0,0,0,13,9ZM9,21V11h4V21Z"
  })), children);
})));
if (false) {}
const LetterRr = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterRr({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16,15V11a2,2,0,0,0-2-2H8V23h2V17h1.48l2.34,6H16l-2.33-6H14A2,2,0,0,0,16,15Zm-6-4h4v4H10Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13 18 13 18 23 20 23 20 15 24 15 24 13z"
  })), children);
})));
if (false) {}
const LetterSs = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterSs({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22,23H17V21h5V19H19a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h5v2H19v2h3a2,2,0,0,1,2,2v2A2,2,0,0,1,22,23Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H7V21h6V17H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,13,23Z"
  })), children);
})));
if (false) {}
const LetterTt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterTt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11 11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23,15V13H20V11H18v2H16v2h2v6a2,2,0,0,0,2,2h3V21H20V15Z"
  })), children);
})));
if (false) {}
const LetterUu = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterUu({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23H19a2,2,0,0,1-2-2V13h2v8h4V13h2v8A2,2,0,0,1,23,23Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z"
  })), children);
})));
if (false) {}
const LetterVv = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterVv({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13 23.25 13 21 22.03 18.79 13 17 13 19.5 23 22.5 23 25 13z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9 11 22 9 9 7 9 9.52 23 12.48 23 15 9 13 9z"
  })), children);
})));
if (false) {}
const LetterWw = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterWw({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 13 23.39 21.61 22 13 20 13 18.61 21.61 17.7 13 16 13 17.36 23 19.64 23 21 14.63 22.36 23 24.64 23 26 13 24.3 13z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 9 11.87 17 11.61 21.54 11.2 18 10.52 12.54 8.5 12.54 7.82 18 7.41 21.54 7.16 17 6.81 9 5.01 9 6.01 23 8.28 23 9.04 18.07 9.5 14 9.51 13.97 9.52 14 9.98 18.07 10.74 23 13.01 23 14.01 9 12.21 9z"
  })), children);
})));
if (false) {}
const LetterXx = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterXx({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9 13 9 11 15 9 9 7 9 9.75 16 7 23 9 23 11 17 13 23 15 23 12.24 16 15 9z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13 23 13 21 16.9 19 13 17 13 19.91 18 17 23 19 23 21 19.2 23 23 25 23 22.1 18 25 13z"
  })), children);
})));
if (false) {}
const LetterYy = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterYy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9 13 9 11 16 9 9 7 9 10 18 10 23 12 23 12 18 12 18 15 9z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23,13l-2,7.52L19.08,13H17l3.15,9.87L19.53,25H17v2h2.26a2,2,0,0,0,1.91-1.42L25,13Z"
  })), children);
})));
if (false) {}
const LetterZz = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LetterZz({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15 25 13 17 13 17 15 22.5 15 17 21 17 23 25 23 25 21 19.51 21 25 15z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9 7 9 7 11 13 11 7 21 7 23 15 23 15 21 9 21 15 11 15 9z"
  })), children);
})));
if (false) {}
const License = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function License({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H22V8H10z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H22V12H10z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H16V26H10z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H16V16H10z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,24,30ZM8,4V28H24V4Z"
  })), children);
})));
if (false) {}
const LicenseDraft = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LicenseDraft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H14V16H8z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H12V26H8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
  })), children);
})));
if (false) {}
const LicenseGlobal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LicenseGlobal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,22,14Zm5.91,7H25.9563a12.03,12.03,0,0,0-1.2183-4.3325A6.01,6.01,0,0,1,27.91,21Zm-7.8545,0A10.0135,10.0135,0,0,1,22,16.0146,10.0121,10.0121,0,0,1,23.9448,21Zm3.89,2A10.01,10.01,0,0,1,22,27.9854,10.0121,10.0121,0,0,1,20.0552,23Zm-4.6831-6.332A12.0265,12.0265,0,0,0,18.0435,21H16.09A6.01,6.01,0,0,1,19.2617,16.668ZM16.09,23h1.9532a12.0265,12.0265,0,0,0,1.2182,4.332A6.01,6.01,0,0,1,16.09,23Zm8.6482,4.332A12.0242,12.0242,0,0,0,25.9565,23H27.91A6.0088,6.0088,0,0,1,24.7385,27.332Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H12V16H6z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H18V8H6z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H18V12H6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H12V26H6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H20a2.0021,2.0021,0,0,1,2,2v8H20V4H4V28h8Z"
  })), children);
})));
if (false) {}
const LicenseMaintenance = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LicenseMaintenance({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H14V16H8z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H14V26H8z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
  })), children);
})));
if (false) {}
const LicenseMaintenanceDraft = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LicenseMaintenanceDraft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13V11H17.8579a3.94,3.94,0,0,0-.4248-1.019L18.95,8.4644,17.5356,7.05,16.019,8.5669A3.9443,3.9443,0,0,0,15,8.1421V6H13V8.1421a3.9443,3.9443,0,0,0-1.019.4248L10.4644,7.05,9.05,8.4644,10.5669,9.981A3.94,3.94,0,0,0,10.1421,11H8v2h2.1421a3.94,3.94,0,0,0,.4248,1.019L9.05,15.5356,10.4644,16.95l1.5166-1.5166A3.9443,3.9443,0,0,0,13,15.8579V18h2V15.8579a3.9443,3.9443,0,0,0,1.019-.4248L17.5356,16.95,18.95,15.5356,17.4331,14.019A3.94,3.94,0,0,0,17.8579,13Zm-6,1a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,14,14Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
  })), children);
})));
if (false) {}
const LicenseThirdParty = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LicenseThirdParty({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H14V16H8z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H14V26H8z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M27,25H21a3,3,0,0,0-3,3v2h2V28a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V28A3,3,0,0,0,27,25Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24a4,4,0,1,0-4-4A4,4,0,0,0,24,24Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,24,18Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
  })), children);
})));
if (false) {}
const LicenseThirdPartyDraft = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LicenseThirdPartyDraft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M17,15H11a3,3,0,0,0-3,3v1h2V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v1h2V18A3,3,0,0,0,17,15Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M14,14a4,4,0,1,0-4-4A4,4,0,0,0,14,14Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,14,8Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
  })), children);
})));
if (false) {}
const Lifesaver = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Lifesaver({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2261,22.812a13.9664,13.9664,0,0,0,0-13.624L28.4141,9a2.0021,2.0021,0,0,0,0-2.8281l-2.5857-2.586a2.0028,2.0028,0,0,0-2.8284,0l-.1877.1875a13.9687,13.9687,0,0,0-13.6243,0L9,3.5859a2.0024,2.0024,0,0,0-2.8284,0L3.5859,6.1719A2.0021,2.0021,0,0,0,3.5859,9l.1878.1875a13.97,13.97,0,0,0,0,13.625L3.5859,23a2.0021,2.0021,0,0,0,0,2.8281l2.5857,2.586a2.0021,2.0021,0,0,0,2.8284,0l.188-.188a13.9687,13.9687,0,0,0,13.6243.0005L23,28.4141a2.0021,2.0021,0,0,0,2.8284,0l2.5857-2.586a2.0021,2.0021,0,0,0,0-2.8281ZM28,16a11.973,11.973,0,0,1-1.2546,5.3315l-3.8948-3.895a6.9808,6.9808,0,0,0,0-2.873l3.8948-3.895A11.973,11.973,0,0,1,28,16ZM27,7.5859l-4.9346,4.9346A7.0434,7.0434,0,0,0,19.48,9.9346L24.4143,5ZM16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21ZM21.3154,5.2705,17.4365,9.1494a6.9808,6.9808,0,0,0-2.873,0L10.6846,5.2705A12.2484,12.2484,0,0,1,21.3154,5.2705ZM7.5859,5l4.9346,4.9346a7.0449,7.0449,0,0,0-2.5859,2.5859L5,7.5859ZM4,16a11.9716,11.9716,0,0,1,1.2546-5.3311l3.8948,3.8946a6.9808,6.9808,0,0,0,0,2.873L5.2546,21.3311A11.9716,11.9716,0,0,1,4,16ZM7.5857,27,5,24.4141,9.9346,19.48a7.0434,7.0434,0,0,0,2.5859,2.5859Zm3.0989-.27,3.8789-3.8789a6.9808,6.9808,0,0,0,2.873,0L21.3154,26.73A12.2484,12.2484,0,0,1,10.6846,26.73Zm13.73.27L19.48,22.0654A7.0449,7.0449,0,0,0,22.0654,19.48L27,24.4141Z"
  })), children);
})));
if (false) {}
const Light = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Light({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 1H8.5V3.5H7.5z"
    })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
      d: "M10.8 3.4H13.3V4.4H10.8z",
      transform: "rotate(-45 12.041 3.923)"
    })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
      d: "M12.5 7.5H15V8.5H12.5z"
    })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
      d: "M11.6 10.8H12.6V13.3H11.6z",
      transform: "rotate(-45 12.075 12.04)"
    })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 12.5H8.5V15H7.5z"
    })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
      d: "M2.7 11.6H5.2V12.6H2.7z",
      transform: "rotate(-45 3.96 12.078)"
    })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
      d: "M1 7.5H3.5V8.5H1z"
    })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
      d: "M3.4 2.7H4.4V5.2H3.4z",
      transform: "rotate(-45 3.925 3.961)"
    })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
      d: "M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V7H15z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.147 7.853)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H30V17H25z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.147 24.146)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25H17V30H15z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.853 24.146)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H7V17H2z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.854 7.853)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
})));
if (false) {}
const LightFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LightFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V7H15z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.147 7.853)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H30V17H25z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.147 24.146)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25H17V30H15z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.853 24.146)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H7V17H2z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.854 7.853)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
})));
if (false) {}
const Lightning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Lightning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
  })), children);
})));
if (false) {}
const Link = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Link({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z"
  })), children);
})));
if (false) {}
const LineThick = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LineThick({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,24.6506L24.6506,4.5l2.8494,2.8494L7.3494,27.5l-2.8494-2.8494Z"
  })), children);
})));
if (false) {}
const LineThin = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LineThin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M5.293,25.2929L25.293,5.2929l1.4141,1.4141L6.707,26.707l-1.4141-1.4141Z"
  })), children);
})));
if (false) {}
const Linux = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Linux({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8945,23.542l-1.7238-3.4473a1.9994,1.9994,0,0,0-1.7886-1.1054h-.4683a14.887,14.887,0,0,0-1.8193-4.5977C23.0647,12.4429,22,10.4277,22,8A6,6,0,0,0,10,8a13.0041,13.0041,0,0,1-2.0486,6.2153,14.7022,14.7022,0,0,0-1.8708,4.7759H5.6184a2.0007,2.0007,0,0,0-1.7893,1.106L2.1055,23.5439a1,1,0,0,0,.0971,1.0508L6.2319,29.92a2.9995,2.9995,0,0,0,3.8482.6519l1.8735-1.1241A13.8223,13.8223,0,0,0,16,30a13.8034,13.8034,0,0,0,4.0488-.5527L21.92,30.57a2.9819,2.9819,0,0,0,1.5385.43,3.0385,3.0385,0,0,0,2.3389-1.1187l4-5.2885A1.001,1.001,0,0,0,29.8945,23.542Zm-7.5683-8.2158a14.8311,14.8311,0,0,1,1.5591,3.6631H21.738a16.6591,16.6591,0,0,0-.98-2.6455,12.7083,12.7083,0,0,1-.8789-2.4454,8.8046,8.8046,0,0,0,1.0034-1.4277l.0384-.0718A30.746,30.746,0,0,0,22.3262,15.3262ZM12,21a9.3959,9.3959,0,0,1,1.0728-3.8516c.2563-.5825.5158-1.1757.726-1.7993a4.0474,4.0474,0,0,0,4.4024,0c.21.6236.47,1.2168.726,1.7993A9.3959,9.3959,0,0,1,20,21c0,1.2881-.4146,3-4,3S12,22.2881,12,21Zm6.5105-8.5752A3.6265,3.6265,0,0,1,16,14a3.6273,3.6273,0,0,1-2.5107-1.5757,7.6356,7.6356,0,0,1,5.0212,0ZM12,8a4,4,0,0,1,8,0,10.9164,10.9164,0,0,0,.4673,3.1152A7.9811,7.9811,0,0,0,19,10.4849V8H17v2.0542a9.2522,9.2522,0,0,0-2,0V8H13v2.4849a7.9019,7.9019,0,0,0-1.4785.6372A10.7093,10.7093,0,0,0,12,8ZM9.7146,15.1592A29.8007,29.8007,0,0,0,11.0693,12.38l.0484.09a8.8046,8.8046,0,0,0,1.0034,1.4277,12.7083,12.7083,0,0,1-.8789,2.4454,16.6574,16.6574,0,0,0-.981,2.6474H8.1047A14.0567,14.0567,0,0,1,9.7146,15.1592Zm1.3708,12.4775L9.0508,28.8574a.9866.9866,0,0,1-1.2529-.1806L4.1724,23.8833l1.4458-2.8921h3.706L11.49,26.3853A1.0036,1.0036,0,0,1,11.0854,27.6367Zm2.316.1177a2.9571,2.9571,0,0,0-.0562-2.11A9.03,9.03,0,0,0,16,26a9.0237,9.0237,0,0,0,2.6562-.3564,2.9889,2.9889,0,0,0-.0546,2.11,13.8722,13.8722,0,0,1-5.2,0Zm10.83.8833a.996.996,0,0,1-1.2827.2178l-2.0342-1.2207h0a1.01,1.01,0,0,1-.396-1.273l2.157-5.3725h3.7058l1.4461,2.892Z"
  })), children);
})));
if (false) {}
const LinuxAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LinuxAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6121,20.5215A6.1582,6.1582,0,0,0,24,16.5254C24,13.4785,21.9812,11,19.5,11A4.2435,4.2435,0,0,0,16,13.06,4.2435,4.2435,0,0,0,12.5,11C10.0188,11,8,13.4785,8,16.5254a6.1593,6.1593,0,0,0,1.3879,3.9961c-.5688.3686-.9389.6416-.988.6787a1,1,0,0,0-.1807,1.4248C8.6592,23.1748,12.6169,28,16,28s7.3408-4.8252,7.7808-5.375A1,1,0,0,0,23.6,21.2C23.551,21.1631,23.1812,20.89,22.6121,20.5215ZM12.5,13c1.3552,0,2.5,1.6143,2.5,3.5254v1.5664a9.1005,9.1005,0,0,0-1.0244.2314A2.6411,2.6411,0,0,0,14,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.38,2.38,0,0,0,.4072,1.3623c-.0813.0415-.1687.0806-.248.1221A4.0291,4.0291,0,0,1,10,16.5254C10,14.6143,11.1448,13,12.5,13ZM16,26c-1.5691,0-3.9648-2.084-5.52-3.8057C11.9,21.2788,14.2656,20,16,20s4.1,1.2788,5.52,2.1943C19.9648,23.916,17.5691,26,16,26Zm4.8408-6.5156c-.0793-.0415-.1667-.0806-.248-.1221A2.38,2.38,0,0,0,21,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.6411,2.6411,0,0,0,.0244.3232A9.1005,9.1005,0,0,0,17,18.0918V16.5254C17,14.6143,18.1448,13,19.5,13S22,14.6143,22,16.5254A4.0291,4.0291,0,0,1,20.8408,19.4844Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30a3.8876,3.8876,0,0,1-4-4V14A10,10,0,0,0,6,14V26a3.8876,3.8876,0,0,1-4,4V28a1.8793,1.8793,0,0,0,2-2V14a12,12,0,0,1,24,0V26a1.8825,1.8825,0,0,0,2,2Z"
  })), children);
})));
if (false) {}
const LinuxNamespace = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LinuxNamespace({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M26 2H28V30H26z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,25H6c-1.1046,0-2-.8954-2-2v-14c0-1.1046.8954-2,2-2h14c1.1046,0,2,.8954,2,2v14c0,1.1046-.8954,2-2,2Zm0-16H6v14h14v-14Z"
  })), children);
})));
if (false) {}
const List = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function List({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H28V8H10z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H28V26H10z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H28V17H10z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H6V17H4z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H6V8H4z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H6V26H4z"
  })), children);
})));
if (false) {}
const ListBoxes = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ListBoxes({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M10,14H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,10,14ZM4,6v6h6.0012L10,6Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H4a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,10,28ZM4,20v6h6.0012L10,20Z"
  })), children);
})));
if (false) {}
const ListBulleted = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ListBulleted({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
      cx: "3.5",
      cy: "4.5",
      r: "1.5"
    })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
      cx: "3.5",
      cy: "11.5",
      r: "1.5"
    })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
      d: "M8 11H15V12H8z"
    })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
      d: "M8 4H15V5H8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "9",
    r: "3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "3"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16z"
  })), children);
})));
if (false) {}
const ListChecked = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ListChecked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.4 12.6 18 6 24.6 3.4 22 2 23.4 6 27.4z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.4 12.6 4 6 10.6 3.4 8 2 9.4 6 13.4z"
  })), children);
})));
if (false) {}
const ListCheckedMirror = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ListCheckedMirror({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.4 28.6 18 22 24.6 19.4 22 18 23.4 22 27.4z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H16V24H2z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.4 28.6 4 22 10.6 19.4 8 18 9.4 22 13.4z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H16V10H2z"
  })), children);
})));
if (false) {}
const ListDropdown = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ListDropdown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V2H2V12h9V30H30V6ZM4,10V4H24V6H11v4ZM28,28H13V8H28Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H17V13H15z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H26V13H19z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17H17V19H15z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H26V19H19z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H17V25H15z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H26V25H19z"
  })), children);
})));
if (false) {}
const ListNumbered = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ListNumbered({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H30V24H16z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H30V10H16z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12 8 4 6 4 6 5 4 5 4 7 6 7 6 12 4 12 4 14 6 14 8 14 10 14 10 12 8 12z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H4V24a2,2,0,0,1,2-2H8V20H4V18H8a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H6v2h4Z"
  })), children);
})));
if (false) {}
const ListNumberedMirror = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ListNumberedMirror({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28h-6v-4c0-1.1,0.9-2,2-2h2v-2h-4v-2h4c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2h-2v2h4V28z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H16V24H2z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12 26 4 24 4 24 5 22 5 22 7 24 7 24 12 22 12 22 14 24 14 26 14 28 14 28 12z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H16V10H2z"
  })), children);
})));
if (false) {}
const ListTree = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ListTree({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M7,4h-2v22c0,1.1025.897,2,2,2h5v-2h-5v-6h5v-2h-5v-6h5v-2h-5v-6ZM16,12h2v-2h-2v2ZM20,10v2h7v-2h-7ZM16,20h2v-2h-2v2ZM20,20h7v-2h-7v2ZM16,28h2v-2h-2v2ZM20,28h7v-2h-7v2Z"
  })), children);
})));
if (false) {}
const LoadBalancerApplication = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LoadBalancerApplication({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H8V30H4z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H18V30H14z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H28V30H24z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V14H15v2H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M9,2V12H23V2Zm2,2h2v6H11Zm10,6H15V4h6Z"
  })), children);
})));
if (false) {}
const LoadBalancerClassic = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LoadBalancerClassic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H8V30H4z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H18V30H14z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H28V30H24z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V12H15v4H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10V2H12v8ZM14,8V4h4V8Z"
  })), children);
})));
if (false) {}
const LoadBalancerGlobal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LoadBalancerGlobal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H8V30H4z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H18V30H14z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H28V30H24z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V12H15v4H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,10Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const LoadBalancerListener = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LoadBalancerListener({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V10H15z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H21V10H19z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H13V10H11z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V13H15v3H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H8V30H4z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H18V30H14z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H28V30H24z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H21V5H11z"
  })), children);
})));
if (false) {}
const LoadBalancerLocal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LoadBalancerLocal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V10H15v6H7a2.0023,2.0023,0,0,0-2,2v6H7V18h8v6h2V18h8v6h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H8V30H4z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H18V30H14z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H28V30H24z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H21V7H11z"
  })), children);
})));
if (false) {}
const LoadBalancerNetwork = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LoadBalancerNetwork({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17V12H15v4H7a2.0023,2.0023,0,0,0-2,2v4H7V18h8v4h2V18h8v4h2V18A2.0023,2.0023,0,0,0,25,16Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10V2H12v8h8ZM14,8V4h4V8Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M26,24a2.9948,2.9948,0,0,0-2.8157,2H18.8157a2.982,2.982,0,0,0-5.6314,0H8.8157a3,3,0,1,0,0,2h4.3686a2.982,2.982,0,0,0,5.6314,0h4.3686A2.9947,2.9947,0,1,0,26,24ZM6,28a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,6,28Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,28Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,26,28Z"
  })), children);
})));
if (false) {}
const LoadBalancerPool = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LoadBalancerPool({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H22V17H10z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7,6.2852A2.9665,2.9665,0,0,0,9,5,3,3,0,1,0,6,8a2.96,2.96,0,0,0,1.2852-.3008L10,10.4141V13h2V9.5859ZM6,6A1,1,0,1,1,7,5,1.0009,1.0009,0,0,1,6,6Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M19,5a3,3,0,1,0-4,2.8154V13h2V7.8159A2.9957,2.9957,0,0,0,19,5ZM16,6a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,6Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2a3.0033,3.0033,0,0,0-3,3,2.9665,2.9665,0,0,0,.3,1.2852L20,9.5859V13h2V10.4141l2.7148-2.7149A2.96,2.96,0,0,0,26,8a3,3,0,0,0,0-6Zm0,4a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,26,6Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M12,19H10v2.5859L7.2854,24.3008A2.9609,2.9609,0,0,0,6,24a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L12,22.4141ZM6,28a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,6,28Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M17,24.1841V19H15v5.1841a3,3,0,1,0,2,0ZM16,28a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,28Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M26,24a2.9609,2.9609,0,0,0-1.2854.3008L22,21.5859V19H20v3.4141l3.3,3.3007A2.9665,2.9665,0,0,0,23,27a3,3,0,1,0,3-3Zm0,4a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,26,28Z"
  })), children);
})));
if (false) {}
const LoadBalancerVpc = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LoadBalancerVpc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H2V24H8ZM4,28H6V26H4Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M19,30H13V24h6Zm-4-2h2V26H15Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H24V24h6Zm-4-2h2V26H26Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,10Zm0-6a2,2,0,1,0,2,2A2.002,2.002,0,0,0,16,4Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16H21a4.0045,4.0045,0,0,1-4-4H15a4.0045,4.0045,0,0,1-4,4H6a2.0023,2.0023,0,0,0-2,2v4H6V18h5A5.9694,5.9694,0,0,0,15,16.46V22h2V16.46A5.9694,5.9694,0,0,0,21,18h5v4h2V18A2.0023,2.0023,0,0,0,26,16Z"
  })), children);
})));
if (false) {}
const Location = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Location({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
})));
if (false) {}
const LocationCompany = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationCompany({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16H17V18H15z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V14H15z"
  })), children);
})));
if (false) {}
const LocationCompanyFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationCompanyFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Zm-4-2H15v2h2Zm0-4H15v2h2Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm1,16H15V16h2Zm0-4H15V12h2Zm4,4H19V10H13v8H11V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z"
  })), children);
})));
if (false) {}
const LocationCurrent = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationCurrent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M4,12.9835a1,1,0,0,0,.6289.9448l9.6015,3.8409,3.8407,9.6019A1,1,0,0,0,19,28h.0162a1.0009,1.0009,0,0,0,.9238-.6582l8-22.0007A1,1,0,0,0,26.658,4.0594l-22,8A1.0011,1.0011,0,0,0,4,12.9835Z"
  })), children);
})));
if (false) {}
const LocationFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,17Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "4",
    fill: "none"
  })), children);
})));
if (false) {}
const LocationHazard = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationHazard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "20.5",
    r: "1.5"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H17V16H15z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
})));
if (false) {}
const LocationHazardFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationHazardFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Zm-1.125-6h2.25V7h-2.25Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2ZM14.875,7h2.25v9h-2.25ZM16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Z"
  })), children);
})));
if (false) {}
const LocationHeart = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationHeart({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
})));
if (false) {}
const LocationHeartFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationHeartFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm4.2109,11.7021L16.002,18l-4.2129-4.2979a2.7992,2.7992,0,0,1,0-3.8964,2.6619,2.6619,0,0,1,3.8159,0l.397.4057.393-.4057a2.6619,2.6619,0,0,1,3.8159,0A2.7992,2.7992,0,0,1,20.2109,13.7021Z"
  })), children);
})));
if (false) {}
const LocationInfo = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationInfo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M17 18 17 11 13 11 13 13 15 13 15 18 12 18 12 20 20 20 20 18 17 18z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m15.5,6c-.8284,0-1.5.6716-1.5,1.5s.6716,1.5,1.5,1.5,1.5-.6716,1.5-1.5-.6716-1.5-1.5-1.5Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30l-8.4355-9.9487c-.0479-.0571-.3481-.4516-.3481-.4516-1.4507-1.9268-2.2163-4.2065-2.2163-6.5998,0-6.0641,4.9346-11,11-11s11,4.9359,11,11c0,2.3933-.7656,4.673-2.2148,6.5973l-.0015.0024s-.3003.3944-.3447.4474l-8.439,9.9528Zm-7.1875-11.605c.001.0007.2334.3083.2866.3744l6.9009,8.1385,6.9102-8.1498c.0439-.0552.2783-.3649.2788-.3656,1.1851-1.5746,1.811-3.4376,1.811-5.3925,0-4.9615-4.0376-9-9-9S7,8.0385,7,13c0,1.9559.627,3.8199,1.8125,5.395h0Z"
  })), children);
})));
if (false) {}
const LocationInfoFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationInfoFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-6.0654,0-11,4.936-11,11,0,2.3931.7656,4.6729,2.2163,6.5996,0,0,.3003.3945.3481.4517l8.4355,9.9487,8.439-9.9526c.0444-.0532.3447-.4478.3447-.4478l.0015-.0024c1.4492-1.9243,2.2148-4.2041,2.2148-6.5972,0-6.064-4.9346-11-11-11Zm-.5,4c.8284,0,1.5.6714,1.5,1.5s-.6716,1.5-1.5,1.5-1.5-.6714-1.5-1.5.6716-1.5,1.5-1.5Zm4.5,14h-8v-2h3v-5h-2v-2h4v7h3v2Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: "0",
    d: "m15.5,6c.8284,0,1.5.6714,1.5,1.5s-.6716,1.5-1.5,1.5-1.5-.6714-1.5-1.5.6716-1.5,1.5-1.5Zm4.5,14h-8v-2h3v-5h-2v-2h4v7h3v2Z"
  })), children);
})));
if (false) {}
const LocationPerson = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationPerson({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,14Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,16,10Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
})));
if (false) {}
const LocationPersonFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationPersonFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Zm-1-8a3,3,0,1,0-3,3A3.0033,3.0033,0,0,0,19,11Zm-2,0a1,1,0,1,1-1-1A1.0011,1.0011,0,0,1,17,11Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "11",
    r: "1"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,6a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,8Zm4,11H18V17H14v2H12V17a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z"
  })), children);
})));
if (false) {}
const LocationSave = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationSave({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30h2V28a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v2h2V28a3.0033,3.0033,0,0,0-3-3H21a3.0033,3.0033,0,0,0-3,3Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,24,24Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,24,18Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3418,10.06l-22-8A1,1,0,0,0,2.06,3.3415l8,22A1.001,1.001,0,0,0,10.9839,26H11a1,1,0,0,0,.9287-.6289L15.77,15.7692l9.6016-3.8408a1,1,0,0,0-.0293-1.8687ZM14.6284,14.0709v0l-.3979.1591-.1591.3979,0,0-3.0269,7.5678L4.6719,4.6715l17.5244,6.3726Z"
  })), children);
})));
if (false) {}
const LocationStar = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationStar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7 17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
})));
if (false) {}
const LocationStarFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LocationStarFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 7 17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm3.6,16L16,15.7085,12.4,18l.6-4.0742-3-2.7529,4.2-.5064L16,7l1.9116,3.6665L22,11.1729l-3,2.7529Z"
  })), children);
})));
if (false) {}
const Locked = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Locked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z"
  })), children);
})));
if (false) {}
const LockedAndBlocked = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LockedAndBlocked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4461,20.1005c-.1386-.0692-.2914-.1052-.4464-.1053h-10c-.5522,0-1.0001.4474-1.0002.9998,0,.1338.0268.2662.0789.3895l5.0268,10.0581c.1694.3388.5158.5527.8946.5527.3788,0,.7253-.2139.8947-.5527l5-10c.2468-.4944.046-1.0953-.4484-1.342h0ZM8,16h16v2h2v-2c0-1.1046-.8954-2-2-2h-2v-6c0-3.3137-2.6863-6-6-6s-6,2.6863-6,6v6h-2c-1.1046,0-2,.8954-2,2v12c0,1.1046.8954,2,2,2h11v-2h-11v-12ZM12,8c0-2.2092,1.7908-4,4-4s4,1.7908,4,4v6h-8v-6Z"
  })), children);
})));
if (false) {}
const LogicalPartition = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogicalPartition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "7",
    r: "1"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22v-4c0-1.1046-.8954-2-2-2h-8v-4h9c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2H15v4H7c-1.1046,0-2,.8954-2,2v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4H15v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4h8v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1Zm-19,6H4v-4h4v4Zm10-4v4h-4v-4h4ZM6,10V4H26v6H6ZM28,28h-4v-4h4v4Z"
  })), children);
})));
if (false) {}
const Login = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Login({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H14a2,2,0,0,1-2-2V25h2v3H26V4H14V7H12V4a2,2,0,0,1,2-2H26a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M14.59 20.59 18.17 17 4 17 4 15 18.17 15 14.59 11.41 16 10 22 16 16 22 14.59 20.59z"
  })), children);
})));
if (false) {}
const LogoAngular = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoAngular({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,16h4.9L16,10.8L13.5,16z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M16,3L3,7.6l2.7,15.8L16,29l10.3-5.6L29,7.6L16,3z M21.1,21.6l-1.5-3.2h-7.1l-1.5,3.2H8.6L16,5.3l7.4,16.2H21.1z"
  })), children);
})));
if (false) {}
const LogoAnsibleCommunity = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoAnsibleCommunity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,27.7L17.5,3.1C17.2,2.4,16.6,2,15.9,2c-0.7,0-1.3,0.4-1.6,1.1L3,30h3.9l4.5-11.1l13.3,10.7c0.5,0.4,0.9,0.6,1.4,0.6 c1,0,1.9-0.7,1.9-1.8C28,28.2,27.9,28,27.8,27.7z M15.9,7.5l6.7,16.4L12.5,16L15.9,7.5z"
  })), children);
})));
if (false) {}
const LogoBluesky = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoBluesky({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2,6.9c2.7,2.1,5.7,6.3,6.8,8.5,1.1-2.2,4-6.4,6.8-8.5,2-1.5,5.2-2.6,5.2,1s-.4,6.2-.7,7c-.9,3.1-4,3.8-6.8,3.4,4.8.8,6.1,3.6,3.4,6.3-5.1,5.2-7.3-1.3-7.8-3,0-.3-.1-.5-.1-.3,0-.1,0,0-.1.3-.6,1.7-2.8,8.2-7.8,3-2.7-2.7-1.4-5.5,3.4-6.3-2.8.5-5.9-.3-6.8-3.4-.2-.9-.7-6.3-.7-7,0-3.7,3.2-2.5,5.2-1,0,0,0,0,0,0Z"
  })), children);
})));
if (false) {}
const LogoDigg = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoDigg({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48,7.6v3.92H2V21H9.28V7.6Zm0,11.2H4.8v-5H6.48Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 11.52H13.2V21.04H10.4z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 7.6H13.2V10.399999999999999H10.4z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M14.32,11.52V21H18.8v1.12H14.32V24.4H21.6V11.52ZM18.8,18.8H17.12v-5H18.8Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M22.72,11.52V21H27.2v1.12H22.72V24.4H30V11.52ZM27.2,18.8H25.52v-5H27.2Z"
  })), children);
})));
if (false) {}
const LogoDiscord = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function LogoDiscord({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path265 || (_path265 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M25.7,7.1C23.9,6.3,22,5.7,20,5.3c0,0-0.1,0-0.1,0c-0.2,0.4-0.5,1-0.7,1.5c-2.2-0.3-4.3-0.3-6.4,0c-0.2-0.5-0.5-1-0.7-1.5 c0,0-0.1,0-0.1,0c-2,0.3-3.9,0.9-5.7,1.8c0,0,0,0,0,0c-3.6,5.4-4.6,10.7-4.1,15.9c0,0,0,0.1,0,0.1c2.4,1.8,4.7,2.8,7,3.5 c0,0,0.1,0,0.1,0c0.5-0.7,1-1.5,1.4-2.3c0,0,0-0.1,0-0.1c-0.8-0.3-1.5-0.6-2.2-1c-0.1,0-0.1-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3 c0,0,0.1,0,0.1,0c4.6,2.1,9.5,2.1,14.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0,0.1,0,0.1c-0.7,0.4-1.4,0.8-2.2,1 c0,0-0.1,0.1,0,0.1c0.4,0.8,0.9,1.6,1.4,2.3c0,0,0.1,0,0.1,0c2.3-0.7,4.6-1.8,7-3.5c0,0,0,0,0-0.1C30.5,17,28.9,11.8,25.7,7.1 C25.7,7.1,25.7,7.1,25.7,7.1z M11.4,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8 C13.9,18.6,12.8,19.9,11.4,19.9z M20.7,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8 C23.2,18.6,22.1,19.9,20.7,19.9z"
  })), children);
});
if (false) {}
const LogoFacebook = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoFacebook({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z"
  })), children);
})));
if (false) {}
const LogoFigma = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoFigma({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6,11.6c1-0.6,1.7-1.5,2.1-2.6c0.4-1.1,0.4-2.2,0.1-3.3c-0.3-1.1-1-2-1.9-2.7c-0.9-0.7-2.1-1-3.2-1h-9.2 c-1.2,0-2.3,0.4-3.2,1C7.2,3.7,6.6,4.7,6.2,5.7C5.9,6.8,5.9,8,6.3,9c0.4,1.1,1.1,2,2.1,2.6c-0.7,0.5-1.4,1.1-1.8,1.9 C6.2,14.3,6,15.1,6,16c0,0.9,0.2,1.7,0.6,2.5c0.4,0.8,1,1.4,1.8,1.9c-1,0.6-1.7,1.5-2.1,2.6c-0.4,1.1-0.4,2.2-0.1,3.3 c0.3,1.1,1,2,2,2.7c0.9,0.7,2.1,1,3.2,1c1.4,0,2.8-0.6,3.9-1.5c1-1,1.6-2.3,1.6-3.7v-4.8c1,0.9,2.3,1.4,3.6,1.4h0.1 c1.2,0,2.3-0.4,3.2-1c0.9-0.7,1.6-1.6,1.9-2.7c0.3-1.1,0.3-2.2-0.1-3.3C25.3,13.1,24.5,12.2,23.6,11.6z M16.9,3.7h3.7 c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2s0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2 c-0.4,0.3-0.8,0.6-1.2,0.8c-0.5,0.2-1,0.2-1.4,0.2h-3.7V3.7z M11.4,3.7h3.7v7h-3.7c-0.9,0-1.8-0.4-2.4-1.1C8.3,9,8,8.1,8,7.2 s0.4-1.8,1-2.4C9.6,4.2,10.5,3.8,11.4,3.7L11.4,3.7z M7.8,16c0-0.9,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.6-1h3.7v7h-3.7 c-1,0-1.9-0.4-2.6-1C8.2,17.8,7.8,16.9,7.8,16L7.8,16z M15.1,24.7c0,1-0.4,1.9-1.1,2.5c-0.7,0.7-1.6,1-2.6,1c-0.5,0-1,0-1.4-0.2 c-0.5-0.2-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.8,0.8-1.2 c0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.2,1.4-0.2h3.7L15.1,24.7z M20.6,19.5h-0.1c-0.9,0-1.8-0.4-2.4-1.1c-0.6-0.7-1-1.5-1-2.4 c0-0.9,0.4-1.8,1-2.4c0.6-0.7,1.5-1,2.4-1.1h0.1c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2 c0.2,0.4,0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.4,0.3-0.8,0.6-1.2,0.8C21.6,19.5,21.1,19.5,20.6,19.5 L20.6,19.5z"
  })), children);
})));
if (false) {}
const LogoFlickr = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoFlickr({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "6"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "16",
    r: "6"
  })), children);
})));
if (false) {}
const LogoGit = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoGit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5242,14.8021L17.2022,2.5241c-.7013-.6988-1.8032-.6988-2.5045,0h0l-2.5045,2.4955,3.2057,3.1943c.8014-.2995,1.6029,0,2.2039.4991.6011.5989.8014,1.3975.5009,2.1961l3.1055,3.0945c.8014-.2995,1.6029,0,2.2039.4991.8014.7986.8014,2.1961,0,2.9947h0c-.8014.7986-2.2039.7986-3.0054,0-.6011-.5989-.8014-1.4973-.5009-2.2959l-2.9052-2.8948v7.5865c1.102.4991,1.5027,1.7968,1.0018,2.8948-.1002.1996-.2004.3993-.4007.5989-.8014.7986-2.2039.7986-3.0054,0h0c-.8014-.7986-.8014-2.1961,0-2.9947h0c.2004-.1996.4007-.3993.7013-.4991v-7.6863c-.3005-.0998-.5009-.2995-.7013-.4991-.6011-.5989-.8014-1.4973-.5009-2.2959l-3.2057-3.1943L2.4759,14.7023c-.7013.6988-.7013,1.7968,0,2.5954h0l12.2218,12.1783c.7013.6988,1.8032.6988,2.5045,0l12.2218-12.1783c.7013-.6988.7013-1.7968,0-2.5954"
  })), children);
})));
if (false) {}
const LogoGithub = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoGithub({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16,2a14,14,0,0,0-4.43,27.28c.7.13,1-.3,1-.67s0-1.21,0-2.38c-3.89.84-4.71-1.88-4.71-1.88A3.71,3.71,0,0,0,6.24,22.3c-1.27-.86.1-.85.1-.85A2.94,2.94,0,0,1,8.48,22.9a3,3,0,0,0,4.08,1.16,2.93,2.93,0,0,1,.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4,5.4,0,0,1,1.44-3.76,5,5,0,0,1,.14-3.7s1.17-.38,3.85,1.43a13.3,13.3,0,0,1,7,0c2.67-1.81,3.84-1.43,3.84-1.43a5,5,0,0,1,.14,3.7,5.4,5.4,0,0,1,1.44,3.76c0,5.38-3.27,6.56-6.39,6.91a3.33,3.33,0,0,1,.95,2.59c0,1.87,0,3.38,0,3.84s.25.81,1,.67A14,14,0,0,0,16,2Z"
  })), children);
})));
if (false) {}
const LogoGitlab = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoGitlab({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "m28.5678,12.8926l-.0366-.0934-3.5388-9.2356c-.072-.181-.1995-.3346-.3642-.4386-.3375-.2095-.7699-.1863-1.083.0582-.1512.1228-.2608.2892-.3141.4765l-2.3894,7.3105h-9.6756l-2.3894-7.3105c-.0518-.1884-.1617-.3556-.3141-.4779-.3131-.2445-.7455-.2677-1.083-.0582-.1643.1045-.2917.2579-.3642.4386l-3.5456,9.2315-.0352.0934c-1.0465,2.7345-.1578,5.8315,2.1796,7.5948l.0122.0095.0325.023,5.3908,4.037,2.667,2.0185,1.6246,1.2265c.3905.2965.9308.2965,1.3213,0l1.6246-1.2265,2.667-2.0185,5.4233-4.0614.0135-.0108c2.3319-1.7635,3.219-4.8551,2.1769-7.5867Z"
  })), children);
})));
if (false) {}
const LogoGlassdoor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoGlassdoor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8281,28H21.1719a3.43,3.43,0,0,0,3.43-3.43V10.3306h-3.43V24.57H7.3981A3.43,3.43,0,0,0,10.8281,28Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1719,4H10.8281a3.43,3.43,0,0,0-3.43,3.43v14.24h3.43V7.43H24.6019A3.43,3.43,0,0,0,21.1719,4Z"
  })), children);
})));
if (false) {}
const LogoInstagram = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoInstagram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.406",
    cy: "9.594",
    r: "1.44"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9.8378A6.1622,6.1622,0,1,0,22.1622,16,6.1622,6.1622,0,0,0,16,9.8378ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6.1622c3.2041,0,3.5837.0122,4.849.07a6.6418,6.6418,0,0,1,2.2283.4132,3.9748,3.9748,0,0,1,2.2774,2.2774,6.6418,6.6418,0,0,1,.4132,2.2283c.0577,1.2653.07,1.6449.07,4.849s-.0122,3.5837-.07,4.849a6.6418,6.6418,0,0,1-.4132,2.2283,3.9748,3.9748,0,0,1-2.2774,2.2774,6.6418,6.6418,0,0,1-2.2283.4132c-1.2652.0577-1.6446.07-4.849.07s-3.5838-.0122-4.849-.07a6.6418,6.6418,0,0,1-2.2283-.4132,3.9748,3.9748,0,0,1-2.2774-2.2774,6.6418,6.6418,0,0,1-.4132-2.2283c-.0577-1.2653-.07-1.6449-.07-4.849s.0122-3.5837.07-4.849a6.6418,6.6418,0,0,1,.4132-2.2283A3.9748,3.9748,0,0,1,8.9227,6.6453a6.6418,6.6418,0,0,1,2.2283-.4132c1.2653-.0577,1.6449-.07,4.849-.07M16,4c-3.259,0-3.6677.0138-4.9476.0722A8.8068,8.8068,0,0,0,8.14,4.63,6.1363,6.1363,0,0,0,4.63,8.14a8.8068,8.8068,0,0,0-.5578,2.9129C4.0138,12.3323,4,12.741,4,16s.0138,3.6677.0722,4.9476A8.8074,8.8074,0,0,0,4.63,23.8605a6.1363,6.1363,0,0,0,3.51,3.51,8.8068,8.8068,0,0,0,2.9129.5578C12.3323,27.9862,12.741,28,16,28s3.6677-.0138,4.9476-.0722a8.8074,8.8074,0,0,0,2.9129-.5578,6.1363,6.1363,0,0,0,3.51-3.51,8.8074,8.8074,0,0,0,.5578-2.9129C27.9862,19.6677,28,19.259,28,16s-.0138-3.6677-.0722-4.9476A8.8068,8.8068,0,0,0,27.37,8.14a6.1363,6.1363,0,0,0-3.51-3.5095,8.8074,8.8074,0,0,0-2.9129-.5578C19.6677,4.0138,19.259,4,16,4Z"
  })), children);
})));
if (false) {}
const LogoInvision = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoInvision({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4v24h24V4H4z M12.1,9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0c-0.8,0-1.4-0.6-1.4-1.4 C10.8,9.6,11.4,9,12.1,9z M21.5,22.2c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1l0.7-2.4c0.1-0.2,0.1-0.5,0.1-0.7 c0-0.8-0.5-1.3-1.2-1.3c-1,0-1.6,0.7-1.9,2L15.9,22h-2.3l0.4-1.7c-0.7,1.1-1.6,1.8-2.8,1.8c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1 l1.1-4.3H8.7L9.2,13h3.9l-1.5,6.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.4,0.2,0.5,0.5,0.6c0.2,0,1.6,0,2.4-1.8l1-4.1h-1.6l0.5-1.8h3.5 l-0.5,2.1c0.6-1.2,1.9-2.2,3.1-2.2c1.3,0,2.4,0.9,2.4,2.7c0,0.5-0.1,1-0.2,1.5l-0.7,2.4c-0.1,0.2-0.1,0.4-0.1,0.6 c0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.7-0.2,1.2-1.5l0.9,0.4C23.7,21.4,22.7,22.2,21.5,22.2z"
  })), children);
})));
if (false) {}
const LogoJupyter = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoJupyter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0766,3.5878a1.69,1.69,0,1,1-1.76-1.5853,1.67,1.67,0,0,1,1.76,1.5853Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2191,23.1113c-4.4866,0-8.43-1.61-10.4688-3.9882a11.1618,11.1618,0,0,0,20.9377,0C24.6541,21.5011,20.7257,23.1113,16.2191,23.1113Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2191,7.6483c4.4867,0,8.43,1.61,10.4689,3.9881a11.1618,11.1618,0,0,0-20.9377,0C7.7892,9.2535,11.7126,7.6483,16.2191,7.6483Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0427,27.7388a2.1085,2.1085,0,1,1-.2031-.7976,2.1278,2.1278,0,0,1,.2031.7976Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26,7.1064A1.2263,1.2263,0,1,1,7.4517,5.83,1.2415,1.2415,0,0,1,6.26,7.1064Z"
  })), children);
})));
if (false) {}
const LogoKeybase = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoKeybase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1233,26.9328a1.1122,1.1122,0,1,1-1.1121-1.1122,1.112,1.112,0,0,1,1.1121,1.1122"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0257,26.9328a1.1122,1.1122,0,1,1-1.1122-1.1122,1.1121,1.1121,0,0,1,1.1122,1.1122"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M9.999 5.797H10.973V6.771H9.999z",
    transform: "rotate(-86.462 10.486 6.284)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4275,16.3825l-.0013.001a13.0868,13.0868,0,0,0-5.1431-4.1825c-.3754-.1667-.7543-.3142-1.1354-.4454.0128-.0314.0277-.0615.04-.0933a4.83,4.83,0,0,0-2.9861-6.319,5.9368,5.9368,0,0,0-1.9962-.3558c-.0366-.1253-.1165-.6743.58-2.1571L14.3742,2q-.17.236-.3368.4661c-.384.5309-.7549,1.0444-1.1029,1.55a2.1657,2.1657,0,0,0-1.4486-.6771L9.8543,3.2377H9.852l-.0025,0c-.0429-.0025-.0864-.0039-.1293-.0039A2.1877,2.1877,0,0,0,7.54,5.2825L7.4388,6.9169l0,.003,0,.0028A2.1882,2.1882,0,0,0,9.4854,9.23l1.1673.0723a5.1711,5.1711,0,0,0,.47,2.688,13.1954,13.1954,0,0,0-4.2637,2.9C3,18.7883,3,23.06,3,26.4916v2.0706l1.524-1.6163A12.3293,12.3293,0,0,0,5.8548,30H7.8367A10.7091,10.7091,0,0,1,5.878,25.51l2.2353-2.3708L6.963,26.745l2.03-1.4774c3.5858-2.61,7.8678-3.2093,12.7263-1.7826a4.6276,4.6276,0,0,0,5.2189-1.468c.0441-.0628.0828-.128.1228-.1926a9.6141,9.6141,0,0,1,.1638,1.7454,12.4214,12.4214,0,0,1-1.61,6.43h1.877A14.4022,14.4022,0,0,0,28.87,23.57,12.2666,12.2666,0,0,0,26.4275,16.3825ZM13.8455,5.9257a1.5872,1.5872,0,0,0,1.3983.7068,4.2111,4.2111,0,0,1,1.44.2719,3.17,3.17,0,0,1,1.0279,5.4638l-.4752-.5849-.0032-.004a1.7048,1.7048,0,0,0-3.0235.9865,3.2143,3.2143,0,0,1-1.899-3.5412,8.4815,8.4815,0,0,1,1.4374-3.466A1.642,1.642,0,0,0,13.8455,5.9257Zm3.49,9.2589-.6072.4962a.2675.2675,0,0,1-.376-.038l-.1264-.1549a.2791.2791,0,0,1,.0394-.3927l.6-.49-1.235-1.5158a.362.362,0,1,1,.5611-.4575l3.4546,4.2517a.3619.3619,0,0,1-.1988.5815.3566.3566,0,0,1-.0816.0094.3609.3609,0,0,1-.2806-.1332l-.3441-.4239-1.2215.9971a.2815.2815,0,0,1-.3965-.04l-.5532-.6775a.2786.2786,0,0,1,.04-.3919l1.2275-1.002ZM9.08,7.0184l.1014-1.6342A.5394.5394,0,0,1,9.72,4.8781l.0326.001,1.6335.1013a.5387.5387,0,0,1,.5046.5716l-.0073.1182a10.6739,10.6739,0,0,0-.9028,2.0046L9.5859,7.5886A.5407.5407,0,0,1,9.08,7.0184ZM25.5944,21.07a2.9883,2.9883,0,0,1-3.4112.8373c-4.5313-1.3305-8.6289-1.0534-12.2124.82l1.9069-5.978-7.203,7.6393a11.67,11.67,0,0,1,3.3532-8.3419,11.4953,11.4953,0,0,1,4.1073-2.6908,5.42,5.42,0,0,0,2.2411,1.2214,4.714,4.714,0,0,0,.5627.12,1.6258,1.6258,0,0,0,.2449,1.6416l.0847.1038a1.6247,1.6247,0,0,0,.2594,1.605l.5532.6777a1.6276,1.6276,0,0,0,2.29.2314l.3314-.2705a1.7079,1.7079,0,0,0,1.9867-2.6535l-1.9427-2.3911a4.88,4.88,0,0,0,.4863-.456,12.449,12.449,0,0,1,1.3829.5181,11.419,11.419,0,0,1,4.5085,3.6838C26.0987,18.7278,26.2745,20.1043,25.5944,21.07Z"
  })), children);
})));
if (false) {}
const LogoKubernetes = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoKubernetes({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M15.134 17.189 15.999 17.605 16.862 17.19 17.076 16.259 16.479 15.512 15.518 15.512 14.919 16.257 15.134 17.189z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2166,13.88l.0024.0019a.5239.5239,0,0,0,.8321-.4013l0-.003.0127-.0063L15.242,10.33c-.2173.0268-.43.0635-.6333.1094a6.2,6.2,0,0,0-2.9727,1.6176l2.5752,1.8257Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8347,16.2622l.003-.001a.5241.5241,0,0,0,.206-.9008l-.0024-.002.0029-.0127-2.3515-2.1035a6.1775,6.1775,0,0,0-.8746,3.9l3.0142-.87Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8645,18.501a.5229.5229,0,0,0-.6059-.3989l-.0034,0-.0049-.0063-3.0908.5249a6.2052,6.2052,0,0,0,2.4863,3.1108l1.1972-2.8935-.0087-.0117.0009-.003A.5184.5184,0,0,0,13.8645,18.501Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4622,19.6431l-.0015-.0025a.53.53,0,0,0-.48-.2759.5269.5269,0,0,0-.4434.2769l-.0015.0029H15.533l-1.52,2.7481a6.2277,6.2277,0,0,0,3.38.1723c.207-.0468.41-.104.6044-.1684l-1.5234-2.7534Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7371,18.09l-.0034,0a.51.51,0,0,0-.1206-.0088.5263.5263,0,0,0-.4546.7319l.001.0024-.004.0054,1.21,2.9234A6.185,6.185,0,0,0,21.86,18.61l-3.1176-.5269Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2893,13.2437,18.951,15.3364l.0014.0064-.0024.0019a.5249.5249,0,0,0,.2055.9014l.0035.0005.0024.0132,3.0293.872a6.2915,6.2915,0,0,0-.9014-3.8881Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9383,13.4673l0,.0029a.5161.5161,0,0,0,.1143.3037.5236.5236,0,0,0,.7192.0967l.0025-.0019.0088.0039,2.5586-1.814a6.2307,6.2307,0,0,0-3.584-1.7285l.1777,3.1357Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3806,19.0376,27.9016,8.2705a1.9057,1.9057,0,0,0-1.038-1.291L16.83,2.1885a1.9332,1.9332,0,0,0-1.6656,0L5.1326,6.9819a1.9072,1.9072,0,0,0-1.0381,1.291L1.6194,19.04A1.89,1.89,0,0,0,1.88,20.499a1.8364,1.8364,0,0,0,.1088.1514l6.9439,8.6338a1.9244,1.9244,0,0,0,1.5.7158l11.1357-.0024a1.9251,1.9251,0,0,0,1.5-.7149L30.01,20.6479A1.8911,1.8911,0,0,0,30.3806,19.0376Zm-3.8115-.13a.6432.6432,0,0,1-.7812.4429l-.0039,0-.0049-.001-.0069-.0019-.0048-.002-.0572-.0117c-.0346-.0068-.07-.0142-.0981-.0215a2.4643,2.4643,0,0,1-.3589-.1328c-.0576-.0249-.1172-.0513-.1807-.0752l-.0175-.0063a5.5192,5.5192,0,0,0-1.0284-.3013.4119.4119,0,0,0-.2954.0981l-.0371.0254-.0019.0015-.002,0c-.0439-.0088-.1748-.0322-.2519-.0444a7.8166,7.8166,0,0,1-3.459,4.351c.0093.022.02.05.0307.0806a.9352.9352,0,0,0,.0669.1567l.002.002-.001.0029-.0166.042a.4148.4148,0,0,0-.03.3091,5.69,5.69,0,0,0,.5322.9517c.0376.0561.0757.1084.1128.1591a2.4,2.4,0,0,1,.2095.32c.0166.0312.0371.0752.0552.1137l.0229.0484a.6083.6083,0,1,1-1.0947.5176l-.0224-.0455c-.0186-.038-.0381-.0776-.0518-.1088a2.5059,2.5059,0,0,1-.1211-.3658c-.0166-.0595-.0337-.1215-.0537-.185l-.0059-.0166a5.5441,5.5441,0,0,0-.4052-.9922.4177.4177,0,0,0-.2627-.1709l-.0415-.0127-.0015,0-.0015-.0019c-.01-.0171-.0337-.0611-.0595-.1075-.0235-.042-.0484-.0874-.0664-.12a7.8868,7.8868,0,0,1-1.0269.3091,7.7588,7.7588,0,0,1-4.51-.3233l-.1352.2442-.002.001a.481.481,0,0,0-.2563.124,2.2827,2.2827,0,0,0-.336.7207c-.04.1172-.08.2383-.1279.3569-.0205.064-.0376.127-.0537.188a2.4747,2.4747,0,0,1-.12.3623c-.0127.03-.0313.0669-.0493.1025l-.0245.0494h0l-.0005.0024-.0019.002a.6773.6773,0,0,1-.5952.3945.5484.5484,0,0,1-.24-.0542.6426.6426,0,0,1-.2578-.86c.0088-.0171.0176-.0371.0274-.0576.0171-.0371.0346-.0757.05-.1045a2.53,2.53,0,0,1,.21-.3222c.0367-.05.0747-.1026.1118-.1578a5.8209,5.8209,0,0,0,.543-.976.5889.5889,0,0,0-.0532-.336l0-.0019,0-.002.1074-.2573a7.8224,7.8224,0,0,1-3.46-4.32l-.2593.0444-.0015-.001-.0264-.0151a.5961.5961,0,0,0-.3159-.106,5.5447,5.5447,0,0,0-1.0283.3013l-.0171.0064c-.062.0239-.1211.0488-.1782.0732a2.4949,2.4949,0,0,1-.3613.1333c-.0308.0083-.0708.0171-.1094.0249l-.0459.01-.0049.0019-.0068.002-.0049.001-.0039,0a.6078.6078,0,1,1-.2695-1.18l.0039-.001.0053-.0015.002,0,.0034-.0009.0469-.0113c.04-.01.081-.02.1133-.0258a2.4132,2.4132,0,0,1,.3808-.0357c.063-.0024.1284-.0054.1958-.0107l.0142-.0015A5.554,5.554,0,0,0,7.77,17.92a.72.72,0,0,0,.231-.227l.0244-.0318.001-.0014.0014,0,.2471-.0718a7.7765,7.7765,0,0,1,1.2246-5.4126l-.19-.17,0-.002-.0044-.0278a.5983.5983,0,0,0-.1153-.3159,5.6171,5.6171,0,0,0-.8916-.6265c-.0585-.0342-.1157-.0649-.1713-.0942a2.4731,2.4731,0,0,1-.3267-.1973c-.0264-.0195-.0586-.0459-.0894-.0713l-.0356-.0288L7.67,10.6387l-.0049-.0039A.7045.7045,0,0,1,7.4041,10.2a.5725.5725,0,0,1,.1128-.4575A.5835.5835,0,0,1,8,9.5288a.7226.7226,0,0,1,.4214.1592l.0361.0283c.0332.0259.07.0552.0972.0781a2.5254,2.5254,0,0,1,.2671.2759c.04.0469.0825.0952.1284.1441l.01.01a5.5221,5.5221,0,0,0,.7989.72.4159.4159,0,0,0,.31.0406l.043-.0069h.0019l.0015.001c.0357.0264.1484.1074.2134.1514a7.7273,7.7273,0,0,1,3.9233-2.24,7.9671,7.9671,0,0,1,1.0816-.1665l.0141-.2515.001-.0014a.6486.6486,0,0,0,.1939-.3076,5.5779,5.5779,0,0,0-.066-1.0791l-.0009-.0088c-.0093-.0664-.021-.13-.0328-.1914a2.5611,2.5611,0,0,1-.0493-.38c-.0009-.03-.0005-.0679,0-.1045l.0005-.05-.0005-.0073,0-.0093a.6088.6088,0,1,1,1.211,0l.0009.0605c.001.0386.0015.0791.0005.11a2.5348,2.5348,0,0,1-.0493.38c-.0117.0615-.0234.125-.0327.1914l-.0039.0317a5.4479,5.4479,0,0,0-.064,1.0567.4132.4132,0,0,0,.1616.2666l.0328.03.0019.0015v.0019c.0015.0435.0083.1836.0137.2637a7.79,7.79,0,0,1,2.7173.7559,7.8812,7.8812,0,0,1,2.2632,1.65l.226-.1612h.002l.0312.002a.5914.5914,0,0,0,.33-.041,5.4885,5.4885,0,0,0,.7871-.71l.0215-.022c.0454-.0478.0869-.0952.1274-.1416a2.57,2.57,0,0,1,.27-.2783c.0263-.0229.062-.05.0967-.0776l.0366-.0288a.6088.6088,0,1,1,.7544.9472l-.0435.0357c-.0307.0254-.063.0517-.0884.0708a2.4733,2.4733,0,0,1-.3266.1968c-.0562.0293-.1143.06-.1734.0947a5.6889,5.6889,0,0,0-.8921.6269.4152.4152,0,0,0-.1079.293l-.0034.044v.0019l-.0014.001c-.0162.0146-.0508.0459-.0914.082s-.0864.0772-.1186.1065a7.7983,7.7983,0,0,1,1.25,5.3994l.24.07.001.001.0171.0254a.6014.6014,0,0,0,.24.2334,5.595,5.595,0,0,0,1.063.1757l.0122.001c.0674.0059.1328.0083.1963.0108a2.4617,2.4617,0,0,1,.38.0356c.0312.0059.0713.0156.11.0254l.0644.0156A.643.643,0,0,1,26.5691,18.9077Z"
  })), children);
})));
if (false) {}
const LogoLinkedin = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoLinkedin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4 H7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3 H21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z"
  })), children);
})));
if (false) {}
const LogoLivestream = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoLivestream({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49,23.71h-.76c-2.26,0-4.52,0-6.78,0a3.12,3.12,0,0,1-2.41-1A14.91,14.91,0,0,1,10,18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84,7.84,0,0,0,2,5.6c1.24,0,2.41,0,3.57,0a45.63,45.63,0,0,1,7,.61,8.09,8.09,0,0,1,6.34,5.09,48.51,48.51,0,0,1,2.17,7.36A26,26,0,0,0,22.49,23.71Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1,26.38a2.93,2.93,0,0,1-2.74-2.64,42.08,42.08,0,0,1-.14-4.9,48,48,0,0,0-.61-7.58,3.75,3.75,0,0,0-.83-2h2.65c.54,0,.73.37.89.78A12.1,12.1,0,0,1,28,13.28c.29,2.72.31,5.45.33,8.18a10.94,10.94,0,0,0,0,1.15c.09.78.4,1.1,1.17,1.08.5,0,.5-.06.5-.06v2.69A8.62,8.62,0,0,1,28.1,26.38Z"
  })), children);
})));
if (false) {}
const LogoMastodon = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoMastodon({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "m29.0581,11.1929c0-6.0742-3.9797-7.8545-3.9797-7.8545-2.0066-.9214-5.4522-1.3091-9.0318-1.3384h-.0879c-3.5798.0293-7.023.417-9.0296,1.3384,0,0-3.98,1.7803-3.98,7.8545,0,1.3911-.0271,3.0537.0171,4.8174.1445,5.9404,1.0889,11.7945,6.5811,13.2481,2.5322.6704,4.7063.8105,6.4573.7144,3.1755-.1758,4.958-1.1333,4.958-1.1333l-.1047-2.3037s-2.269.7153-4.8176.6284c-2.5249-.0869-5.1902-.2725-5.5986-3.3726-.0378-.272-.0566-.563-.0566-.8691,0,0,2.4785.606,5.6196.75,1.9207.0879,3.7219-.1128,5.5515-.3311,3.5083-.4189,6.563-2.5806,6.9468-4.5557.605-3.1113.5552-7.5928.5552-7.5928Zm-4.6943,7.8257h-2.9138v-7.1382c0-1.5049-.6331-2.2686-1.8997-2.2686-1.4002,0-2.1018.9058-2.1018,2.6973v3.9077h-2.8967v-3.9077c0-1.7915-.7019-2.6973-2.1021-2.6973-1.2666,0-1.8997.7637-1.8997,2.2686v7.1382h-2.9138v-7.3545c0-1.5029.3828-2.6978,1.1516-3.5811.7927-.8838,1.8308-1.3369,3.1196-1.3369,1.491,0,2.6204.5732,3.367,1.7192l.7256,1.2168.7261-1.2168c.7463-1.146,1.8755-1.7192,3.3667-1.7192,1.2886,0,2.3267.4531,3.1196,1.3369.7686.8833,1.1514,2.0781,1.1514,3.5811v7.3545Z"
  })), children);
})));
if (false) {}
const LogoMedium = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoMedium({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16c0,3.7-0.6,6.7-1.4,6.7c-0.8,0-1.4-3-1.4-6.7s0.6-6.7,1.4-6.7C29.4,9.3,30,12.3,30,16"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,16c0,4.1-1.8,7.5-3.9,7.5s-3.9-3.4-3.9-7.5s1.8-7.5,3.9-7.5S26.5,11.9,26.5,16"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,16c0,4.4-3.5,8-7.9,8S2,20.4,2,16s3.5-8,7.9-8S17.8,11.6,17.8,16"
  })), children);
})));
if (false) {}
const LogoModelContextProtocol = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoModelContextProtocol({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2916,25.8339c-.1264.1266-.1264.3324,0,.459l2.0453,2.0453c.3803.3801.3803.9964,0,1.3766-.19.1901-.4392.2852-.6883.2852s-.4983-.0951-.6883-.2852l-2.0454-2.0453c-.8856-.8855-.8856-2.3266,0-3.2121l9.9609-9.9609c.5515-.5516.8554-1.285.8554-2.065s-.3039-1.5134-.8554-2.0651l-.0574-.0574c-1.1387-1.1386-2.9916-1.1387-4.1303,0l-8.2027,8.2027-.1147.1147c-.1901.1901-.4392.2852-.6884.2852s-.4983-.0951-.6884-.2852c-.3802-.3801-.3802-.9964,0-1.3766l.1147-.1147,8.2029-8.2029c.5515-.5516.8553-1.285.8553-2.0651s-.3037-1.5134-.8553-2.065c-.5517-.5516-1.285-.8554-2.0651-.8554s-1.5134.3037-2.065.8554L5.168,15.8159c-.3801.3801-.9966.3801-1.3767,0s-.3802-.9965,0-1.3767L14.8049,3.4256c.9194-.9193,2.1417-1.4256,3.4417-1.4256s2.5226.5063,3.4419,1.4256c.9193.9193,1.4255,2.1416,1.4255,3.4417,0,.2332-.0169.4637-.049.6906,1.4645-.2075,3.0061.2505,4.1301,1.3745l.0574.0574c.9194.9193,1.4258,2.1416,1.4258,3.4418s-.5064,2.5224-1.4258,3.4417l-9.9608,9.9608ZM24.4417,13.0625c.3803-.3802.3803-.9965,0-1.3767-.3799-.3801-.9966-.3801-1.3766,0l-8.1455,8.1454c-1.1384,1.1387-2.9912,1.1387-4.1301.0002-.5516-.5517-.8554-1.2851-.8554-2.0651s.3038-1.5134.8554-2.0651l8.1453-8.1455c.3803-.3802.3803-.9965,0-1.3767-.3799-.3801-.9966-.3801-1.3766,0l-8.1455,8.1455c-.9194.9194-1.4257,2.1418-1.4257,3.4418s.5063,2.5224,1.4257,3.4419c.9489.9488,2.1953,1.4231,3.4417,1.4231s2.4929-.4744,3.4418-1.4233l8.1454-8.1454Z"
  })), children);
})));
if (false) {}
const LogoNpm = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoNpm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M4,28V4h24v24H4z M8.5,8.5v15H16v-12h4.5v12h3v-15H8.5z"
  })), children);
})));
if (false) {}
const LogoOpenshift = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoOpenshift({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4612,15.7968A12.1352,12.1352,0,0,0,25.2821,11.48L29,10.13a11.9879,11.9879,0,0,0-1.0281-1.7382l-1.7431.635a11.9884,11.9884,0,0,0-21.71,7.9129l1.7477-.6412a12.19,12.19,0,0,0,.3309,1.9846L2.8838,19.6384A12.1451,12.1451,0,0,0,4.7565,23.7l1.9663-.7163.0026.0039a11.8856,11.8856,0,0,0,4.67,3.8909A12.013,12.013,0,0,0,27.34,21.0743a11.8725,11.8725,0,0,0,1.08-5.992Zm-2.92,3.4967a7.8,7.8,0,0,1-10.3533,3.7744,7.7207,7.7207,0,0,1-2.2714-1.6128l-1.9846.7235a7.84,7.84,0,0,1-2.0742-3.9895l.0009-.0008,3.7242-1.3566a7.8175,7.8175,0,0,1-.1232-2.0653l-1.7517.6362A7.7729,7.7729,0,0,1,19.7645,8.94h.0067a7.7442,7.7442,0,0,1,2.2646,1.615L23.78,9.921a7.8014,7.8014,0,0,1,1.229,1.6558l-3.71,1.3595a7.8245,7.8245,0,0,1,.9766,4.3882l1.9685-.7151A7.6714,7.6714,0,0,1,23.5411,19.2935Z"
  })), children);
})));
if (false) {}
const LogoPinterest = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoPinterest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a14,14,0,0,0-5.1,27,13.24,13.24,0,0,1,0-4l1.65-7A5.05,5.05,0,0,1,12.17,16c0-1.94,1.13-3.4,2.53-3.4a1.76,1.76,0,0,1,1.77,2c0,1.2-.76,3-1.16,4.66a2,2,0,0,0,2.08,2.53c2.48,0,4.4-2.63,4.4-6.41a5.53,5.53,0,0,0-5.85-5.7,6.06,6.06,0,0,0-6.32,6.08,5.42,5.42,0,0,0,1,3.19.44.44,0,0,1,.1.4c-.11.44-.35,1.4-.39,1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43,0-4.41,3.21-8.47,9.25-8.47,4.85,0,8.63,3.46,8.63,8.09,0,4.82-3,8.7-7.27,8.7a3.76,3.76,0,0,1-3.21-1.6l-.87,3.33a15.55,15.55,0,0,1-1.74,3.67A14.17,14.17,0,0,0,16,30,14,14,0,0,0,16,2"
  })), children);
})));
if (false) {}
const LogoPython = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoPython({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4882,9.14v2.9663a4.2843,4.2843,0,0,1-4.173,4.2352H12.6431a3.4077,3.4077,0,0,0-3.34,3.3945v6.3607c0,1.81,1.5742,2.8751,3.34,3.3945a11.1762,11.1762,0,0,0,6.6721,0c1.6817-.4869,3.34-1.4668,3.34-3.3945V23.55H15.983v-.8486H25.9951c1.9414,0,2.6648-1.3542,3.34-3.3867a11.4642,11.4642,0,0,0,0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867ZM19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8351,2a19.0717,19.0717,0,0,0-3.192.2725c-2.8268.4994-3.34,1.5447-3.34,3.4723V8.2909h6.68V9.14H6.7962a4.1708,4.1708,0,0,0-4.173,3.3867,12.4855,12.4855,0,0,0,0,6.7889c.4748,1.9776,1.6088,3.3867,3.55,3.3867H8.47V19.65a4.2449,4.2449,0,0,1,4.173-4.15h6.6721a3.3654,3.3654,0,0,0,3.34-3.3944V5.745a3.729,3.729,0,0,0-3.34-3.4723A20.8377,20.8377,0,0,0,15.8351,2ZM12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
  })), children);
})));
if (false) {}
const LogoQuora = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoQuora({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M29,23.86H27a1.72,1.72,0,0,1-1.73,1.72c-1.15,0-1.82-.86-2.58-2a11,11,0,0,0,4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3,7.37,3,14.37,9,26.16,15.17,26.16a10.71,10.71,0,0,0,3.07-.48c1.15,2.11,2.59,3.74,5.46,3.74A5,5,0,0,0,29,23.86Zm-8.14-3.45a6.31,6.31,0,0,0-5.56-3.16,6,6,0,0,0-3.74,1.15L12.2,20a2.56,2.56,0,0,1,.86-.1c1.82,0,3,1.53,4.12,3.64a7.58,7.58,0,0,1-1.91.19C10.86,23.76,9,20.6,9,14.47s1.91-9.3,6.23-9.3,6.32,3.16,6.32,9.3A20.68,20.68,0,0,1,20.83,20.41Z"
  })), children);
})));
if (false) {}
const LogoRScript = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoRScript({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M30,14.7842c0-5.1782-6.2681-9.376-14-9.376S2,9.606,2,14.7842c0,4.6147,4.9814,8.4419,11.5361,9.2226v2.9917l4.7762-.0019,0-2.9741a19.3812,19.3812,0,0,0,3.3418-.6646L23.593,27l5.3975-.0024-3.253-5.4849C28.3625,19.8086,30,17.4263,30,14.7842Zm-22.4983.7c0-3.54,4.7644-6.41,10.6414-6.41s10.2138,1.9629,10.2138,6.41A5.4694,5.4694,0,0,1,24.9587,20.61a3.2252,3.2252,0,0,0-.2978-.1749,10.4735,10.4735,0,0,0-1.34-.5048s4.1743-.31,4.1743-4.4659-4.3684-4.2343-4.3684-4.2343H13.5361V21.2554C9.97,20.22,7.5017,18.0283,7.5017,15.4839Zm13.7422,1.8452-2.8928.001.0014-2.6812,2.8914.0015a1.2476,1.2476,0,0,1,1.34,1.3149A1.3232,1.3232,0,0,1,21.2439,17.3291Zm-2.9326,3.4946h1.2825a.8785.8785,0,0,1,.6406.291,3.2917,3.2917,0,0,1,.51.63,22.4033,22.4033,0,0,1-2.4326.1455Z"
  })), children);
})));
if (false) {}
const LogoReact = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoReact({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.2,0.1-0.4,0.1-0.6c0.7-3.3,0.2-6-1.3-6.9c-1.5-0.8-3.9,0-6.3,2.1 c-0.2,0.2-0.5,0.4-0.7,0.6c-0.2-0.1-0.3-0.3-0.5-0.4C13,3.9,10.5,3,9,3.9c-1.5,0.8-1.9,3.4-1.3,6.5c0.1,0.3,0.1,0.6,0.2,0.9 c-0.4,0.1-0.7,0.2-1,0.3c-3,1-4.9,2.7-4.9,4.3c0,1.7,2,3.5,5.1,4.5c0.2,0.1,0.5,0.2,0.8,0.2c-0.1,0.3-0.2,0.7-0.2,1 c-0.6,3.1-0.1,5.5,1.3,6.4c1.5,0.9,4,0,6.5-2.2c0.2-0.2,0.4-0.4,0.6-0.5c0.2,0.2,0.5,0.5,0.8,0.7c2.4,2.1,4.7,2.9,6.2,2 c1.5-0.9,2-3.5,1.4-6.7c0-0.2-0.1-0.5-0.2-0.8c0.2-0.1,0.4-0.1,0.5-0.2c3.2-1.1,5.3-2.8,5.3-4.5C30,14.3,28,12.7,25,11.6z M17.5,6.9 c2.1-1.8,4-2.5,4.9-2c0.9,0.5,1.3,2.7,0.7,5.6c0,0.2-0.1,0.4-0.1,0.6c-1.2-0.3-2.5-0.5-3.7-0.6c-0.7-1-1.5-2-2.4-3 C17.1,7.3,17.3,7.1,17.5,6.9L17.5,6.9z M10.3,17.4c0.3,0.5,0.5,1,0.8,1.5c0.3,0.5,0.6,1,0.9,1.4c-0.9-0.1-1.7-0.2-2.6-0.4 C9.6,19.1,9.9,18.3,10.3,17.4z M10.3,14.6c-0.4-0.8-0.6-1.6-0.9-2.4c0.8-0.2,1.7-0.3,2.5-0.4c-0.3,0.5-0.6,0.9-0.9,1.4 C10.8,13.6,10.5,14.1,10.3,14.6L10.3,14.6z M10.9,16c0.4-0.8,0.8-1.5,1.2-2.3c0.4-0.7,0.9-1.5,1.4-2.2c0.8-0.1,1.7-0.1,2.6-0.1 c0.9,0,1.7,0,2.6,0.1c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.8,1.5,1.2,2.3c-0.4,0.8-0.8,1.5-1.2,2.3c-0.4,0.7-0.9,1.5-1.3,2.2 c-0.8,0.1-1.7,0.1-2.6,0.1c-0.9,0-1.7,0-2.5-0.1c-0.5-0.7-0.9-1.4-1.4-2.2C11.7,17.5,11.3,16.8,10.9,16L10.9,16z M20.9,18.9 c0.3-0.5,0.6-1,0.8-1.5c0.4,0.8,0.7,1.6,0.9,2.5c-0.9,0.2-1.7,0.3-2.6,0.4C20.4,19.8,20.7,19.3,20.9,18.9z M21.7,14.6 c-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.5-0.6-0.9-0.8-1.4c0.9,0.1,1.7,0.3,2.6,0.4C22.4,13,22.1,13.8,21.7,14.6z M16,8.3 c0.6,0.6,1.1,1.3,1.6,2c-1.1-0.1-2.2-0.1-3.3,0C14.9,9.6,15.5,8.9,16,8.3z M9.6,4.9c0.9-0.5,3,0.2,5.2,2.2c0.1,0.1,0.3,0.3,0.4,0.4 c-0.9,0.9-1.7,1.9-2.4,3c-1.3,0.1-2.5,0.3-3.7,0.6c-0.1-0.3-0.1-0.6-0.2-0.9C8.3,7.5,8.7,5.4,9.6,4.9z M8.2,19.6 c-0.2-0.1-0.5-0.1-0.7-0.2c-1.4-0.5-2.5-1.1-3.3-1.7c-0.7-0.6-1-1.2-1-1.7c0-1,1.5-2.3,4.1-3.2c0.3-0.1,0.6-0.2,1-0.3 C8.6,13.7,9,14.9,9.6,16C9,17.2,8.6,18.4,8.2,19.6z M14.7,25.1c-1.1,1-2.2,1.6-3.1,2c-0.9,0.3-1.5,0.3-2,0.1 c-0.9-0.5-1.3-2.5-0.8-5.1C8.9,21.7,9,21.4,9,21c1.2,0.3,2.5,0.5,3.8,0.5c0.7,1,1.5,2,2.4,3C15,24.7,14.9,24.9,14.7,25.1z M16,23.7 c-0.6-0.6-1.1-1.3-1.7-2c0.5,0,1.1,0,1.6,0c0.6,0,1.1,0,1.7,0C17.2,22.4,16.6,23.1,16,23.7z M23.3,25.4c-0.2,0.9-0.5,1.5-0.9,1.7 c-0.9,0.5-2.8-0.2-4.8-1.9c-0.2-0.2-0.5-0.4-0.7-0.6c0.8-0.9,1.6-1.9,2.3-3c1.3-0.1,2.5-0.3,3.8-0.6c0.1,0.2,0.1,0.5,0.2,0.7 C23.5,23.1,23.5,24.4,23.3,25.4z M24.3,19.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4-1.2-0.9-2.4-1.4-3.6c0.5-1.1,1-2.3,1.4-3.5 c0.3,0.1,0.6,0.2,0.8,0.3c2.6,0.9,4.2,2.2,4.2,3.2C28.8,17.1,27.1,18.5,24.3,19.4z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18.5c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-0.9-0.7-1.3 c-0.3-0.4-0.8-0.6-1.3-0.7c-0.5-0.1-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.3,0.1,0.7,0.2,1 c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5C15.3,18.4,15.7,18.5,16,18.5z"
  })), children);
})));
if (false) {}
const LogoRedHatAiInstructlabOnIbmCloud = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoRedHatAiInstructlabOnIbmCloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2148,13.1793c.2327-.501-.4158-.9337-.9252-.8189-.3831.0863-.8737.7158-1.0126,1.0705.0842.5294,1.6957.2715,1.9378-.2516ZM12.8453,12.7614c.06.5895-.6263.5432-1.0515.5242.2484-.3642.5768-.7484,1.0515-.5242ZM16,21.8211c.9062-.0084,1.2-1.8673.4673-2.0052-.0768-.0137-.2548-.0231-.4673-.0253-.2126.0021-.3906.0116-.4674.0253-.7326.1379-.4389,1.9968.4674,2.0052ZM12.154,19.6017c1.2337-.0746,1.1996-2.8773-.0815-2.8101-1.4228.0746-1.2452,2.8903.0815,2.8101ZM26.8406,9.7584c-.52-.6715-1.2484-2.2767-2.0789-2.4473-1.2431-.2547-2.1147.3842-2.923,1.221-1.6652-1.2252-3.7147-2.3188-5.8387-2.3052-2.1241-.0137-4.1736,1.08-5.8387,2.3052-.8084-.8368-1.68-1.4757-2.9231-1.221-.8305.1705-1.5589,1.7758-2.0789,2.4473-.9073,1.1747-3.1978,3.1746-3.1588,4.7346.0484,1.9073,4.4714,7.2376,6.3776,7.5229.4211.0631.7842-.0421,1.1874-.0842.7214,1.4147,1.8981,2.4644,3.2742,3.1268,1.9797.953,4.3409.953,6.3207,0,1.376-.6624,2.5527-1.7121,3.2742-3.1268.4031.0421.7662.1473,1.1873.0842,1.9062-.2853,6.3292-5.6156,6.3777-7.5229.0389-1.56-2.2515-3.5599-3.1589-4.7346h-.0001ZM11.1285,9.2016c1.6884-1.1799,3.2167-1.8304,4.8715-1.7957,1.6547-.0347,3.183.6158,4.8714,1.7957.3747.261,1.4536,1.0516,1.6978,1.3547.5905.7305.5526,3.2515.5853,4.204h-2.1263c-.9337,0-1.8673.001-2.801,0-.3168,0-.6905.201-.9157.421-.6642.6505-.2316,1.52-.2632,2.3157-.3494-.1453-.6979-.2-1.0483-.2084-.3505.0084-.699.0632-1.0484.2084-.0316-.7958.401-1.6652-.2632-2.3157-.2252-.22-.5989-.421-.9157-.421-.9337.001-1.8673,0-2.801,0h-2.1263c.0327-.9526-.0052-3.4736.5853-4.204.2442-.3032,1.3231-1.0937,1.6978-1.3547ZM8.6855,20.9191c-1.3947-.0516-5.3871-4.9725-5.5187-6.3293-.1126-1.1673,2.2062-3.2589,2.9399-4.1998.3547-.4537,1.14-2.0147,1.641-2.0473.4168-.0263,1.3157.5378,1.5052.9052.3968.7684-.179.8516-.4274,1.4389-.5137,1.2126-.3632,2.7736-.4127,4.062-.782.1769-1.4136.5273-1.361,1.4294.0253.4453.9062,3.3241,1.141,3.7094.3074.5042.8189.7263,1.3894.7684l-.8968.2632h0ZM9.3718,20.2338c-.4716.0221-.7389-.319-.9337-.6968-.2158-.4189-1.0146-3.0568-1.0431-3.4894-.0347-.52.5684-.8505,1.0294-.8652,0,1.7273.481,3.4041.9473,5.0514h0ZM8.8455,15.1814h5.1051c.3379.0674.7642.5432.7852.9.0264.4274-.3221,2.5242-.4452,3.0189-.0569.2274-.1937.6463-.3453.8126-.5737.6305-3.1567.1979-4.0346.3084-.5968-1.6241-.8789-3.3209-1.0652-5.0399ZM16,24.7495c-2.481-.18-4.9062-1.5852-5.7861-4.0946.9337-.0937,2.0989.1274,2.9999,0,1.6063-.2263,1.34-1.7242,1.7368-2.8957.3389-.1053.6926-.1579,1.0494-.1705.3568.0126.7104.0652,1.0494.1705.3968,1.1715.1305,2.6694,1.7368,2.8957.901.1274,2.0662-.0937,2.9999,0-.8799,2.5094-3.3051,3.9146-5.7861,4.0946ZM18.0546,19.9128c-.1516-.1663-.2884-.5853-.3452-.8126-.1232-.4947-.4716-2.5915-.4453-3.0189.0211-.3568.4473-.8326.7852-.9h5.1051c-.1863,1.7189-.4684,3.4157-1.0652,5.0399-.8779-.1105-3.4609.3221-4.0346-.3084ZM23.5755,15.1825c.4611.0147,1.0641.3452,1.0294.8652-.0284.4326-.8273,3.0704-1.0431,3.4894-.1948.3779-.4621.7189-.9337.6968.4663-1.6473.9473-3.3241.9473-5.0514h.0001ZM23.3144,20.9191l-.8968-.2632c.5705-.0421,1.082-.2642,1.3894-.7684.2347-.3853,1.1157-3.2641,1.141-3.7094.0527-.9021-.5789-1.2526-1.361-1.4294-.0495-1.2883.101-2.8494-.4127-4.062-.2484-.5873-.8242-.6705-.4273-1.4389.1895-.3674,1.0884-.9315,1.5052-.9052.501.0326,1.2863,1.5936,1.641,2.0473.7336.941,3.0526,3.0325,2.9399,4.1998-.1315,1.3568-4.124,6.2777-5.5187,6.3293h0ZM20.723,13.4309c-.1389-.3547-.6295-.9842-1.0126-1.0705-.5095-.1147-1.1579.3179-.9252.8189.2421.5231,1.8536.781,1.9378.2516ZM20.2061,13.2857c-.4252.0189-1.1115.0652-1.0515-.5242.4747-.2242.8031.16,1.0515.5242ZM16,22.0274c-.6074,1.041-1.6042.2295-2.3115-.4252.3514,1.0421,1.1141,1.8438,1.985,2.1157.2104.0657.4424.0657.6529,0,.871-.2719,1.6337-1.0736,1.985-2.1157-.7073.6547-1.7042,1.4662-2.3115.4252h.0001ZM16.4631,23.3104c-.2929.1281-.6333.1281-.9262,0-.213-.0932-.4126-.2253-.5853-.3925.3663-.0379.7895-.0547,1.0484-.2895.2589.2347.682.2516,1.0483.2895-.1727.1671-.3723.2993-.5853.3925h.0001ZM19.9274,16.7916c-1.2811-.0672-1.3152,2.7355-.0814,2.8101,1.3266.0803,1.5042-2.7354.0814-2.8101Z"
  })), children);
})));
if (false) {}
const LogoRedHatAnsible = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoRedHatAnsible({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9104,20.5859h0l-5-11c-.1577-.3452-.5061-.5859-.9104-.5859s-.7529,.2407-.9104,.5859l-5,11c-.0576,.1265-.0896,.2661-.0896,.4141,0,.5522,.4478,1,1,1,.4043,0,.7527-.2407,.9104-.5859l1.9985-4.3965,6.4978,4.7876c.166,.1226,.3711,.1948,.5933,.1948,.5522,0,1-.4478,1-1,0-.1479-.032-.2881-.0896-.4141Zm-5.9104-8.1689l2.499,5.498-3.7441-2.7588,1.2451-2.7393Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-7.7197,0-14-6.2803-14-14S8.2803,2,16,2s14,6.2803,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3833-12,12s5.3833,12,12,12,12-5.3833,12-12-5.3833-12-12-12Z"
  })), children);
})));
if (false) {}
const LogoSketch = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoSketch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1,3.2l7.7,0.9c0.2,0,0.3,0.1,0.4,0.2l5.7,7.7c0.2,0.2,0.2,0.5,0,0.7l-13.6,16c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0 l-13.6-16C2,12.5,2,12.2,2.1,12l5.7-7.7c0.1-0.1,0.2-0.2,0.4-0.2l7.7-0.9C16,3.2,16,3.2,16.1,3.2z M17.7,4.8c0,0-0.1,0-0.2,0 c0,0-0.1,0.1,0,0.2l0,0l4.3,5.4c0,0.1,0.1,0.1,0.1,0.2c0,0.2-0.1,0.3-0.3,0.3l0,0H10.4c-0.1,0-0.1,0-0.2-0.1 c-0.1-0.1-0.1-0.3-0.1-0.4l0,0L14.5,5c0,0,0-0.1,0-0.2c0,0-0.1,0-0.2,0l0,0l-5.9,5.9c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2v0 l0.2-4.3c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1l0,0l-1.1,4.9c0,0.2-0.2,0.3-0.3,0.3l0,0l-2.8,0.6c-0.1,0-0.1,0.1-0.1,0.1 c0,0.1,0,0.1,0.1,0.1l0,0h2.7c0.2,0,0.3,0.1,0.4,0.2l0,0l6.6,11.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2l0,0L8.6,12.9 c0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.3-0.4l0,0h14.2c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.2,0.4l0,0l-5.3,11.3c0,0.1,0,0.2,0.1,0.2 c0.1,0,0.2,0,0.2-0.1l0,0L25,12.6c0.1-0.1,0.2-0.2,0.4-0.2l0,0h2.7c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1l0,0l-2.8-0.6 c-0.2,0-0.3-0.2-0.4-0.3l0,0L24,6.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1v0l0.2,4.3c0,0.1,0,0.1-0.1,0.2 c-0.1,0.1-0.2,0.1-0.3,0l0,0L17.7,4.8z"
  })), children);
})));
if (false) {}
const LogoSkype = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoSkype({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M27.91,17.88A11.63,11.63,0,0,0,28.06,16,12.06,12.06,0,0,0,16,3.94a11.63,11.63,0,0,0-1.88.15,7.29,7.29,0,0,0-10,10A11.63,11.63,0,0,0,3.94,16,12.06,12.06,0,0,0,16,28.06a11.63,11.63,0,0,0,1.88-.15,7.29,7.29,0,0,0,10-10Zm-6.18,3.6a5,5,0,0,1-2.24,1.73,9,9,0,0,1-3.48.62A8.41,8.41,0,0,1,12,23a5.2,5.2,0,0,1-1.82-1.63,3.59,3.59,0,0,1-.7-2,1.36,1.36,0,0,1,.43-1A1.56,1.56,0,0,1,11,18a1.38,1.38,0,0,1,.91.32,2.5,2.5,0,0,1,.63.94,5.83,5.83,0,0,0,.66,1.18,2.61,2.61,0,0,0,1,.78,3.87,3.87,0,0,0,1.69.31,4,4,0,0,0,2.34-.62,1.8,1.8,0,0,0,.89-1.53,1.54,1.54,0,0,0-.47-1.17,3.09,3.09,0,0,0-1.25-.7c-.52-.17-1.21-.34-2.08-.53A16,16,0,0,1,12.41,16a4.78,4.78,0,0,1-1.89-1.4,3.5,3.5,0,0,1-.7-2.21,3.65,3.65,0,0,1,.74-2.24,4.7,4.7,0,0,1,2.14-1.5A9.51,9.51,0,0,1,16,8.17a8.63,8.63,0,0,1,2.59.35,5.81,5.81,0,0,1,1.83.92,3.91,3.91,0,0,1,1.06,1.21,2.62,2.62,0,0,1,.34,1.25,1.4,1.4,0,0,1-.43,1,1.43,1.43,0,0,1-1.07.46,1.25,1.25,0,0,1-.89-.28,3.36,3.36,0,0,1-.65-.87,3.79,3.79,0,0,0-1.05-1.31,3.13,3.13,0,0,0-1.95-.46,3.64,3.64,0,0,0-2,.5,1.44,1.44,0,0,0-.76,1.2,1.15,1.15,0,0,0,.25.75,2.21,2.21,0,0,0,.72.55,4.74,4.74,0,0,0,.92.36c.32.09.84.22,1.57.39.92.2,1.74.42,2.49.66a7.61,7.61,0,0,1,1.9.88,3.59,3.59,0,0,1,1.23,1.31A4,4,0,0,1,22.5,19,4.24,4.24,0,0,1,21.73,21.48Z"
  })), children);
})));
if (false) {}
const LogoSlack = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoSlack({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0423,19.1661A2.5212,2.5212,0,1,1,6.5212,16.645H9.0423Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3127,19.1661a2.5212,2.5212,0,0,1,5.0423,0v6.3127a2.5212,2.5212,0,1,1-5.0423,0Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8339,9.0423A2.5212,2.5212,0,1,1,15.355,6.5212V9.0423Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8339,10.3127a2.5212,2.5212,0,0,1,0,5.0423H6.5212a2.5212,2.5212,0,1,1,0-5.0423Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9577,12.8339a2.5212,2.5212,0,1,1,2.5211,2.5211H22.9577Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6873,12.8339a2.5212,2.5212,0,0,1-5.0423,0V6.5212a2.5212,2.5212,0,1,1,5.0423,0Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1661,22.9577a2.5212,2.5212,0,1,1-2.5211,2.5211V22.9577Z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1661,21.6873a2.5212,2.5212,0,0,1,0-5.0423h6.3127a2.5212,2.5212,0,1,1,0,5.0423Z"
  })), children);
})));
if (false) {}
const LogoSnapchat = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoSnapchat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9774,9.6279a7.33,7.33,0,0,0-.1186-1.2888,5.2458,5.2458,0,0,0-.4872-1.4948,5.1869,5.1869,0,0,0-.9988-1.3324,4.9557,4.9557,0,0,0-2.1805-1.2433,8.8444,8.8444,0,0,0-2.3059-.2458l-.0044-.0119H10.1143l-.0007.0119a12.578,12.578,0,0,0-1.3221.0591A6.2955,6.2955,0,0,0,7.3792,4.4,5.1155,5.1155,0,0,0,4.2538,7.8152a8.8,8.8,0,0,0-.2459,2.2855L4,21.9065a14.9206,14.9206,0,0,0,.1088,1.5992A5.53,5.53,0,0,0,4.6,25.1205a5.17,5.17,0,0,0,1.443,1.744,4.6907,4.6907,0,0,0,1.4442.7822,7.83,7.83,0,0,0,2.3741.3484c.5034.0032,1.0069.0158,1.5106.0137,3.659-.0154,7.3178.0264,10.9767-.0226a8.6316,8.6316,0,0,0,1.44-.1528A4.8765,4.8765,0,0,0,26.2,26.6613a4.9915,4.9915,0,0,0,1.5931-2.6546,9.6646,9.6646,0,0,0,.2074-2.1v-.1407C28,21.7112,27.9793,9.7855,27.9774,9.6279ZM24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24.7635,20.7326c-.1536.36-.93.6577-2.2433.8606-.1232.019-.1751.2183-.2463.5445-.0293.1348-.0592.2669-.1.4057a.2451.2451,0,0,1-.26.1943h-.0205a2.1011,2.1011,0,0,1-.3738-.0472,4.921,4.921,0,0,0-.9852-.1044,4.37,4.37,0,0,0-.7106.06,3.4048,3.4048,0,0,0-1.3483.6888,3.912,3.912,0,0,1-2.3668.9328c-.05,0-.0973-.0018-.1335-.0035-.0287.0024-.0584.0035-.0881.0035a3.9062,3.9062,0,0,1-2.3651-.9322,3.4118,3.4118,0,0,0-1.35-.69,4.3612,4.3612,0,0,0-.71-.06,4.858,4.858,0,0,0-.9852.1115,2.1872,2.1872,0,0,1-.3737.0536.2574.2574,0,0,1-.2807-.2012c-.0414-.1407-.0711-.277-.1-.4082-.0716-.328-.1237-.5282-.2465-.5472-1.3133-.2026-2.0893-.5011-2.2439-.8626a.3349.3349,0,0,1-.0272-.114.2109.2109,0,0,1,.1764-.22,4.5854,4.5854,0,0,0,2.7564-1.6391,6.1681,6.1681,0,0,0,.94-1.4616l.0048-.01a.943.943,0,0,0,.09-.79c-.1693-.3991-.73-.5769-1.1007-.6946-.0921-.0291-.1794-.0567-.2488-.0844-.3288-.13-.8693-.4041-.7973-.7828a.7333.7333,0,0,1,.7127-.4683.5052.5052,0,0,1,.2158.043,2.1572,2.1572,0,0,0,.8916.2355.7465.7465,0,0,0,.5134-.1569q-.0145-.2629-.0318-.5256a8.8742,8.8742,0,0,1,.2122-3.5447A4.6074,4.6074,0,0,1,15.8173,7.76q.177-.0015.3539-.0033a4.6152,4.6152,0,0,1,4.2853,2.7606,8.884,8.884,0,0,1,.2118,3.5478l-.0036.0574c-.01.1629-.02.317-.0278.4665a.7215.7215,0,0,0,.4656.1558,2.2321,2.2321,0,0,0,.84-.234.6628.6628,0,0,1,.2751-.0545.832.832,0,0,1,.3133.06l.005.0019a.5825.5825,0,0,1,.4409.4781c.0034.1835-.133.4578-.8039.7226-.0687.0272-.1564.0551-.2489.0844-.3712.1178-.9312.2956-1.1005.6944a.9422.9422,0,0,0,.09.7893l.0048.01a5.4311,5.4311,0,0,0,3.6967,3.1005.211.211,0,0,1,.1764.22A.3408.3408,0,0,1,24.7635,20.7326Z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const LogoSvelte = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoSvelte({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1,5.7C23.5,2,18.4,0.9,14.7,3.2L8.2,7.4c-1.8,1.1-3,2.9-3.4,5c-0.3,1.7,0,3.5,0.8,5.1c-0.6,0.8-0.9,1.8-1.1,2.8 c-0.4,2.1,0.1,4.3,1.4,6c2.6,3.7,7.7,4.8,11.4,2.5l6.5-4.2c1.8-1.1,3-2.9,3.4-5c0.3-1.7,0-3.5-0.8-5.1c0.6-0.8,0.9-1.8,1.1-2.8 C27.9,9.6,27.4,7.4,26.1,5.7z M24.3,11c0,0.2-0.1,0.4-0.2,0.6L24,12l-0.3-0.2c-0.8-0.6-1.6-1-2.6-1.3l-0.2-0.1l0-0.2 c0-0.3-0.1-0.7-0.3-1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2L12,12.9c-0.3,0.2-0.5,0.5-0.6,0.9c-0.1,0.4,0,0.8,0.2,1.1 c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l2.5-1.6c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1c0.7,1,1,2.4,0.8,3.6 c-0.2,1.2-1,2.3-2,3l-6.5,4.2c-0.4,0.3-0.9,0.5-1.3,0.6c-2.1,0.5-4.3-0.3-5.6-2.1c-0.7-1-1-2.4-0.8-3.6c0-0.2,0.1-0.4,0.2-0.6L8,20 l0.3,0.2c0.8,0.6,1.6,1,2.6,1.3l0.2,0.1l0,0.2c0,0.3,0.1,0.7,0.3,1c0.4,0.5,1,0.8,1.7,0.6c0.1,0,0.3-0.1,0.4-0.2l6.5-4.2 c0.3-0.2,0.5-0.5,0.6-0.9c0.1-0.4,0-0.8-0.2-1.1c-0.4-0.5-1-0.8-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2l-2.5,1.6c-0.4,0.3-0.9,0.5-1.3,0.6 c-2.1,0.5-4.3-0.3-5.6-2.1c-0.8-1-1-2.4-0.8-3.6c0.2-1.2,1-2.3,2-3l6.5-4.2c0.4-0.3,0.9-0.5,1.3-0.6c2.1-0.5,4.3,0.3,5.6,2.1 C24.2,8.5,24.5,9.8,24.3,11z"
  })), children);
})));
if (false) {}
const LogoTumblr = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoTumblr({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,28h-4c-3.59,0-6.3-1.86-6.3-6.3V14.58H9V10.72A7.17,7.17,0,0,0,14.3,4h3.76v6.12h4.36v4.46H18.06v6.2c0,1.86.94,2.49,2.42,2.49H22.6Z"
  })), children);
})));
if (false) {}
const LogoTwitter = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoTwitter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5475,25.7523c9.0566,0,14.0102-7.5034,14.0102-14.0102,0-.2131,0-.4253-.0144-.6365,.9637-.697,1.7955-1.5601,2.4566-2.5488-.8987,.3982-1.852,.6594-2.8282,.7747,1.0279-.6154,1.7972-1.5833,2.1648-2.7235-.9666,.5736-2.024,.9778-3.1267,1.1952-1.8648-1.9829-4.984-2.0786-6.9669-.2138-1.2788,1.2026-1.8214,2.9947-1.4245,4.7047-3.9591-.1985-7.6479-2.0685-10.1482-5.1446-1.3069,2.2499-.6394,5.1282,1.5245,6.5731-.7836-.0232-1.5501-.2346-2.2349-.6163v.0624c.0006,2.3439,1.6529,4.3628,3.9504,4.8269-.7249,.1977-1.4855,.2266-2.2234,.0845,.6451,2.0058,2.4937,3.38,4.6003,3.4195-1.7436,1.3703-3.8975,2.1142-6.1152,2.112-.3918-.0008-.7832-.0245-1.1722-.071,2.2518,1.4451,4.8719,2.2116,7.5475,2.208"
  })), children);
})));
if (false) {}
const LogoVmware = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoVmware({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4,11C3,10.1,2,9.7,1,10.2s-1.3,1.4-0.9,2.3L4.1,21c0.6,1.3,1.3,2,2.5,2c1.3,0,1.9-0.8,2.5-2c0,0,3.4-7.4,3.4-7.5 c0-0.1,0.1-0.3,0.5-0.3c0.3,0,0.5,0.2,0.5,0.6V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9 V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2V15c0-1.1,0.8-1.9,1.9-1.9c1.1,0,1.9,0.8,1.9,1.9V21c0,1.1,0.6,2,1.8,2s1.8-0.9,1.8-2v-6.8 c0-2.5-2-4.2-4.4-4.2s-3.9,1.7-3.9,1.7c-0.8-1-1.9-1.7-3.8-1.7c-2,0-3.7,1.7-3.7,1.7c-0.8-1-2.2-1.7-3.3-1.7c-1.7,0-3.1,0.8-4,2.7 l-2.5,5.9L3.4,11"
  })), children);
})));
if (false) {}
const LogoVmwareAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoVmwareAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4131,19.1099l-1.9154-5.5355c-.0401-.1304-.1003-.351-.1003-.5415,0-.5114,.4112-1.0128,1.073-1.0128,.5515,0,.9226,.351,1.083,.8624l1.2034,3.9812,1.2335-3.9711c.1604-.5315,.5716-.8925,1.1432-.8925h.1304c.5716,0,.9828,.371,1.1432,.8925l1.2435,3.9812,1.2335-4.0113c.1504-.4713,.4814-.8524,1.073-.8524,.6117,0,1.0429,.4713,1.0429,1.0229,0,.1504-.0401,.351-.0702,.4513l-2.0056,5.6258c-.2306,.6919-.6919,.9928-1.2335,.9928h-.0702c-.5415,0-.9928-.3109-1.2034-.9527l-1.2435-3.9511-1.2635,3.9511c-.2006,.6418-.6619,.9527-1.2034,.9527h-.0702c-.5315,0-.9928-.3109-1.2234-.9928Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0939,12.645c-.2469-.5532-.8692-.8001-1.452-.5433-.5828,.2568-.7902,.8989-.5334,1.452l2.4299,5.2846c.3852,.8297,.7902,1.2644,1.5409,1.2644,.81,0,1.1656-.4741,1.5409-1.2644,0,0,2.1237-4.6228,2.1435-4.6722,.0198-.0494,.0889-.1976,.3062-.1976,.1877,0,.3358,.1482,.3358,.3457v4.524c0,.6914,.3852,1.2644,1.1261,1.2644s1.1458-.5729,1.1458-1.2644v-3.6943c0-.7112,.5136-1.1755,1.2051-1.1755s1.1557,.4741,1.1557,1.1755v3.6943c0,.6914,.3852,1.2644,1.1261,1.2644s1.1458-.5729,1.1458-1.2644v-3.6943c0-.7112,.5136-1.1755,1.2051-1.1755s1.1557,.4741,1.1557,1.1755v3.6943c0,.6914,.3852,1.2644,1.1261,1.2644s1.1458-.5729,1.1458-1.2644v-4.2079c0-1.5508-1.2446-2.6275-2.7361-2.6275s-2.4299,1.0372-2.4299,1.0372c-.4939-.6421-1.1853-1.0372-2.341-1.0372-1.2248,0-2.3015,1.0372-2.3015,1.0372-.5038-.6421-1.3434-1.0372-2.0447-1.0372-1.0866,0-1.9459,.4741-2.4694,1.6792l-1.5508,3.6647-1.9756-4.7018"
  })), children);
})));
if (false) {}
const LogoVue = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoVue({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,3.9L16,19.4L7.1,3.9H2l14,24.3L30,3.9H24.9z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9.5l-3.2-5.6H8.1L16,17.5l7.9-13.6h-4.6L16,9.5z"
  })), children);
})));
if (false) {}
const LogoWechat = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoWechat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.0857,24.7792A6.6179,6.6179,0,0,0,30,19.4662c0-3.88-3.7765-7.0269-8.4338-7.0269s-8.4339,3.1465-8.4339,7.0269,3.7765,7.028,8.4339,7.028a9.9547,9.9547,0,0,0,2.7533-.385l.2473-.0374a.8923.8923,0,0,1,.448.13l1.8469,1.0664.1621.0525a.2813.2813,0,0,0,.2812-.2812l-.0455-.2053-.38-1.4175-.0292-.18A.56.56,0,0,1,27.0857,24.7792ZM12.1208,4.68C6.5313,4.68,2,8.4552,2,13.1137a7.9386,7.9386,0,0,0,3.4965,6.3746.6713.6713,0,0,1,.2835.55l-.035.2147-.4562,1.701L5.234,22.2a.3384.3384,0,0,0,.3372.3383l.196-.063,2.2155-1.28a1.0584,1.0584,0,0,1,.5366-.1552l.2975.0443a11.9674,11.9674,0,0,0,3.304.4632l.5554-.014a6.5153,6.5153,0,0,1-.3395-2.0662c0-4.2478,4.1323-7.6918,9.2295-7.6918l.55.014C21.3538,7.761,17.169,4.68,12.1208,4.68Zm6.6337,13.6629a1.1247,1.1247,0,1,1,1.1247-1.1247A1.1243,1.1243,0,0,1,18.7545,18.3427Zm5.6233,0a1.1247,1.1247,0,1,1,1.1235-1.1247A1.1245,1.1245,0,0,1,24.3778,18.3427ZM8.7468,11.7638a1.3493,1.3493,0,1,1,1.35-1.3486A1.3485,1.3485,0,0,1,8.7468,11.7638Zm6.7469,0a1.3493,1.3493,0,1,1,1.35-1.3486A1.3486,1.3486,0,0,1,15.4937,11.7638Z"
  })), children);
})));
if (false) {}
const LogoX = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoX({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "m18.2342,14.1624l8.7424-10.1624h-2.0717l-7.591,8.8238-6.0629-8.8238h-6.9929l9.1684,13.3432-9.1684,10.6568h2.0718l8.0163-9.3183,6.4029,9.3183h6.9929l-9.5083-13.8376h.0005Zm-2.8376,3.2984l-.9289-1.3287L7.0763,5.5596h3.1822l5.9649,8.5323.9289,1.3287,7.7536,11.0907h-3.1822l-6.3272-9.05v-.0005Z"
  })), children);
})));
if (false) {}




/***/ }),

/***/ 1657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K5": function() { return /* binding */ SendAltFilled; }
/* harmony export */ });
/* unused harmony exports ScanAlt, ScanDisabled, ScatterMatrix, Schematics, ScisControlTower, ScisTransparentSupply, Scooter, ScooterFront, Screen, ScreenMap, ScreenMapSet, ScreenOff, Script, ScriptReference, Sdk, Search, SearchAdvanced, SearchLocate, SearchLocateMirror, Security, SecurityServices, SelectWindow, Select_01, Select_02, Send, SendActionUsage, SendAlt, SendBackward, SendFilled, SendToBack, ServerDns, ServerProxy, ServerTime, ServerlessFleet, ServiceDesk, ServiceId, ServiceLevels, SessionBorderControl, Settings, SettingsAdjust, SettingsCheck, SettingsEdit, SettingsServices, SettingsView, Shadow, ShapeExcept, ShapeExclude, ShapeIntersect, ShapeJoin, ShapeUnite, Shapes, Share, ShareKnowledge, ShoppingBag, ShoppingCart, ShoppingCartArrowDown, ShoppingCartArrowUp, ShoppingCartClear, ShoppingCartError, ShoppingCartMinus, ShoppingCartPlus, ShoppingCatalog, ShowDataCards, ShrinkScreen, ShrinkScreenFilled, Shuffle, Shuttle, SidePanelClose, SidePanelCloseFilled, SidePanelOpen, SidePanelOpenFilled, Sight, Sigma, SignalStrength, SimCard, SkillLevel, SkillLevelAdvanced, SkillLevelBasic, SkillLevelIntermediate, SkipBack, SkipBackFilled, SkipBackOutline, SkipBackOutlineFilled, SkipBackOutlineSolid, SkipBackSolidFilled, SkipForward, SkipForwardFilled, SkipForwardOutline, SkipForwardOutlineFilled, SkipForwardOutlineSolid, SkipForwardSolidFilled, Sleet, Slisor, Slm, Smell, Smoke, Snooze, Snow, SnowBlizzard, SnowDensity, SnowHeavy, SnowScattered, SnowScatteredNight, Snowflake, Soccer, SoftwareResource, SoftwareResourceCluster, SoftwareResourceResource, SoilMoisture, SoilMoistureField, SoilMoistureGlobal, SoilTemperature, SoilTemperatureField, SoilTemperatureGlobal, SolarPanel, SortAscending, SortDescending, SortRemove, SortingAToZ, SortingHighestToLowestNumber, SortingLowestToHighestNumber, SortingZToA, WatsonHealthSmoothing, WatsonHealthSmoothingCursor */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1239);
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */






var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle, _circle2, _circle3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _circle4, _path91, _circle5, _path92, _path93, _circle6, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _circle7, _circle8, _circle9, _circle0, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _circle1, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _circle10, _circle11, _path149, _circle12, _circle13, _path150, _path151, _circle14, _circle15, _path152, _path153, _circle16, _circle17, _path154, _path155, _circle18, _circle19, _path156, _path157, _circle20, _circle21, _path158, _path159, _circle22, _circle23, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _rect, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _circle24, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _circle25, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _circle26, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _circle27, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435;
const ScanAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScanAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,24H10a2,2,0,0,1-2-2V19h2v3H22V19h2v3A2,2,0,0,1,22,24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H30V17H2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13H22V10H10v3H8V10a2,2,0,0,1,2-2H22a2,2,0,0,1,2,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10 28 10 28 4 22 4 22 2 30 2 30 10z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10 2 10 2 2 10 2 10 4 4 4 4 10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30 2 30 2 22 4 22 4 28 10 28 10 30z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30 22 30 22 28 28 28 28 22 30 22 30 30z"
  })), children);
})));
if (false) {}
const ScanDisabled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScanDisabled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3826,2.0762a.9993.9993,0,0,0-1.09.2168l-26,26A1,1,0,0,0,3,30h8V28H5.4143l4-4H22a2.0021,2.0021,0,0,0,2-2V9.4146l4-4V11h2V3A1,1,0,0,0,29.3826,2.0762ZM22,22H11.4143L22,11.4146Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10,17.7554V10h7.7554l2-2H10a2.0025,2.0025,0,0,0-2,2v9.7554Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2 2 2 2 11 4 11 4 4 11 4 11 2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30 30 30 30 21 28 21 28 28 21 28 21 30z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23.755 4 21 2 21 2 25.754 4 23.755z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.755 2 21 2 21 4 23.755 4 25.755 2z"
  })), children);
})));
if (false) {}
const ScatterMatrix = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScatterMatrix({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "9.5",
    cy: "9.5",
    r: "2.5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.5",
    cy: "22.5",
    r: "2.5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.5",
    cy: "22.5",
    r: "2.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
  })), children);
})));
if (false) {}
const Schematics = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Schematics({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
  })), children);
})));
if (false) {}
const ScisControlTower = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScisControlTower({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2 C5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3 c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6 c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1 s0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S27.6,23,27,23z"
  })), children);
})));
if (false) {}
const ScisTransparentSupply = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScisTransparentSupply({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22H19V19H13v3H11V19a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,16Zm0-4a1,1,0,1,0,1,1A1.0013,1.0013,0,0,0,16,12Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z"
  })), children);
})));
if (false) {}
const Scooter = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Scooter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,26,28Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,26,22Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8H18v2h6a1,1,0,0,1,0,2H21a1,1,0,0,0-.98,1.1963l.9241,4.6211L18.4338,22h-2.69l-2.5723-8.5752A1.988,1.988,0,0,0,11.2559,12H6v2h5.2561l.6,2H7a5.0057,5.0057,0,0,0-5,5v2a1,1,0,0,0,1,1H4a4,4,0,0,0,8,0h7a1,1,0,0,0,.8574-.4854l3-5a1,1,0,0,0,.1231-.7109L22.22,14H24a3,3,0,0,0,0-6ZM8,26a2.0025,2.0025,0,0,1-2-2h4A2.0025,2.0025,0,0,1,8,26ZM4,22V21a3.0033,3.0033,0,0,1,3-3h5.4561l1.2,4Z"
  })), children);
})));
if (false) {}
const ScooterFront = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScooterFront({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H17V28H15z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
  })), children);
})));
if (false) {}
const Screen = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Screen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
  })), children);
})));
if (false) {}
const ScreenOff = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScreenOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
  })), children);
})));
if (false) {}
const ScreenMap = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScreenMap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22 25H30V27H22z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21H30V23H22z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4141 11 23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z"
  })), children);
})));
if (false) {}
const ScreenMapSet = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScreenMapSet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H31V28H24z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22H31V24H24z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4141 12 25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z"
  })), children);
})));
if (false) {}
const Script = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Script({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18.83 26 21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.17 26 24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
  })), children);
})));
if (false) {}
const ScriptReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScriptReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.17 26 24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.83 26 21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V16H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10A.9092.9092,0,0,0,25.7,9.3ZM18,10V4.4L23.6,10Z"
  })), children);
})));
if (false) {}
const Sdk = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Sdk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9 27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23H12V9h4a4.0118,4.0118,0,0,1,4,4v6A4.0118,4.0118,0,0,1,16,23Zm-2-2h2a2.0059,2.0059,0,0,0,2-2V13a2.0059,2.0059,0,0,0-2-2H14Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8,23H2V21H8V17H4a2.0059,2.0059,0,0,1-2-2V11A2.0059,2.0059,0,0,1,4,9h6v2H4v4H8a2.0059,2.0059,0,0,1,2,2v4A2.0059,2.0059,0,0,1,8,23Z"
  })), children);
})));
if (false) {}
const Search = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Search({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
      d: "M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5 C2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"
  })), children);
})));
if (false) {}
const SearchAdvanced = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SearchAdvanced({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6 26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M24,28.5859l-5.9751-5.9751a9.0234,9.0234,0,1,0-1.4141,1.4141L22.5859,30ZM4,17a7,7,0,1,1,7,7A7.0078,7.0078,0,0,1,4,17Z"
  })), children);
})));
if (false) {}
const SearchLocate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SearchLocate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.5859l-4.6885-4.6884a8.028,8.028,0,1,0-1.414,1.414L28.5859,30ZM19,25a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,19,25Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H10V14H2z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H18V4H2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H18V9H2z"
  })), children);
})));
if (false) {}
const SearchLocateMirror = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SearchLocateMirror({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M21,28.6l-4.7-4.7c1.1-1.4,1.7-3.1,1.7-4.9c0-4.4-3.6-8-8-8s-8,3.6-8,8s3.6,8,8,8c1.8,0,3.5-0.6,4.9-1.7l4.7,4.7L21,28.6z M10,25c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S13.3,25,10,25z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12H30V14H22z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H30V9H14z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H30V4H14z"
  })), children);
})));
if (false) {}
const Security = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Security({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.59 11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
  })), children);
})));
if (false) {}
const SecurityServices = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SecurityServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26.667l-3.2344-1.7246A8.9858,8.9858,0,0,1,6,17V4H26V14h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,28.9336Z"
  })), children);
})));
if (false) {}
const Select_01 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Select_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6 8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20V8H16z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24,6V8h4v4h2V8a2,2,0,0,0-2-2Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H8V20H6z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28V24H6v4a2,2,0,0,0,2,2h4V28Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16H30V20H28z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H20V30H16z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24v4H24v2h4a2,2,0,0,0,2-2V24Z"
  })), children);
})));
if (false) {}
const Select_02 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Select_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6 8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10ZM8,28H6V26H8Zm20,0H26V26h2ZM26,6h2V8H26Z"
  })), children);
})));
if (false) {}
const SelectWindow = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SelectWindow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M8,26H4a2.0021,2.0021,0,0,1-2-2V20H4v4H8Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H4V16H2z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26,8H24V4H20V2h4a2.0021,2.0021,0,0,1,2,2Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H16V4H12z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M4,8H2V4A2.0021,2.0021,0,0,1,4,2H8V4H4Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M27,32a.9967.9967,0,0,1-.707-.293l-6.1377-6.1377L16.832,30.5547a1,1,0,0,1-1.79-.2676l-6-20A1,1,0,0,1,10.2871,9.042l20,6a1,1,0,0,1,.2676,1.79l-4.9854,3.3233L31.707,26.293a.9994.9994,0,0,1,0,1.414l-4,4A.9967.9967,0,0,1,27,32Zm0-2.4141L29.5859,27,22.431,19.845l5.2458-3.4978L11.4917,11.4917l4.8555,16.1851L19.845,22.431Z"
  })), children);
})));
if (false) {}
const Send = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Send({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
  })), children);
})));
if (false) {}
const SendAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SendAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
  })), children);
})));
if (false) {}
const SendAltFilled = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function SendAltFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
  })), children);
});
if (false) {}
const SendFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SendFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
  })), children);
})));
if (false) {}
const SendActionUsage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SendActionUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9,21c-.5523,0-1-.4477-1-1v-8c0-.5523.4477-1,1-1h11.1716c.5304,0,1.0391.2107,1.4142.5858l4.4142,4.4142-4.4142,4.4142c-.3751.3751-.8838.5858-1.4142.5858h-11.1715Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
})));
if (false) {}
const SendBackward = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SendBackward({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M4,7H2V4A2.0023,2.0023,0,0,1,4,2H7V4H4Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M7,22H4a2.0023,2.0023,0,0,1-2-2V17H4v3H7Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H4V14H2z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M22,7H20V4H17V2h3a2.0023,2.0023,0,0,1,2,2Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2H14V4H10z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H12a2.0023,2.0023,0,0,1-2-2V12a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30ZM12,12V28H28V12Z"
  })), children);
})));
if (false) {}
const SendToBack = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SendToBack({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM12,28V12H28l.0015,16Z"
  })), children);
})));
if (false) {}
const ServerDns = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ServerDns({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,2Zm5.91,7H19.4724a15.2457,15.2457,0,0,0-.7917-4.36A6.0088,6.0088,0,0,1,21.91,9ZM16.022,15.999h-.0076c-.3813-.1206-1.3091-1.8213-1.479-4.999h2.9292C17.2952,14.1763,16.3711,15.877,16.022,15.999ZM14.5354,9c.1694-3.1763,1.0935-4.877,1.4426-4.999h.0076c.3813.1206,1.3091,1.8213,1.479,4.999ZM13.3193,4.64A15.2457,15.2457,0,0,0,12.5276,9H10.09A6.0088,6.0088,0,0,1,13.3193,4.64ZM10.09,11h2.4373a15.2457,15.2457,0,0,0,.7917,4.36A6.0088,6.0088,0,0,1,10.09,11Zm8.59,4.36A15.2457,15.2457,0,0,0,19.4724,11H21.91A6.0088,6.0088,0,0,1,18.6807,15.36Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
})));
if (false) {}
const ServerProxy = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ServerProxy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "25",
    r: "1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2,24.59,3.41,27.17,6H22.315A6.9835,6.9835,0,0,0,9.08,10H4.83L7.41,7.41,6,6,1,11l5,5,1.41-1.41L4.83,12H9.685A6.9835,6.9835,0,0,0,22.92,8h4.25l-2.58,2.59L26,12l5-5ZM21,9a4.983,4.983,0,0,1-8.9745,3H16V10H11.1011a4.9852,4.9852,0,0,1,8.8734-4H16V8h4.8989A5.0019,5.0019,0,0,1,21,9Z"
  })), children);
})));
if (false) {}
const ServerTime = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ServerTime({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.586 17 9.586 17 6 15 6 15 10.414 17.586 13 19 11.586z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,18ZM16,4a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const ServerlessFleet = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ServerlessFleet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 19.3 17.3 20.7 21 24.4 28.7 16.7 27.3 15.3 21 21.6 18.7 19.3z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M10,12v11c0,1.1.9,2,2,2h4v-2h-4v-11h8v4h2v-4c0-1.1-.9-2-2-2h-8c-1.1,0-2,.9-2,2Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4h8v-2H4c-1.1,0-2,.9-2,2v8h2V4Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M6,8v8h2v-8h8v-2h-8c-1.1,0-2,.9-2,2Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22v6H4v-6h-2v6c0,1.1.9,2,2,2h24c1.1,0,2-.9,2-2v-6h-2Z"
  })), children);
})));
if (false) {}
const ServiceDesk = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ServiceDesk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
    transform: "translate(0 .005)"
  })), children);
})));
if (false) {}
const ServiceId = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ServiceId({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24v-2h-2.101c-0.13-0.637-0.384-1.229-0.732-1.753l1.49-1.49l-1.414-1.414l-1.49,1.49 c-0.524-0.348-1.116-0.602-1.753-0.732V16h-2v2.101c-0.637,0.13-1.229,0.384-1.753,0.732l-1.49-1.49l-1.414,1.414l1.49,1.49 c-0.348,0.524-0.602,1.116-0.732,1.753H16v2h2.101c0.13,0.637,0.384,1.229,0.732,1.753l-1.49,1.49l1.414,1.414l1.49-1.49 c0.524,0.348,1.116,0.602,1.753,0.732V30h2v-2.101c0.637-0.13,1.229-0.384,1.753-0.732l1.49,1.49l1.414-1.414l-1.49-1.49 c0.348-0.524,0.602-1.116,0.732-1.753H30z M23,26c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S24.654,26,23,26z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H16V8H12z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M6,28V4h16v9h2V4c0-1.103-0.897-2-2-2H6C4.897,2,4,2.897,4,4v24c0,1.103,0.897,2,2,2h8v-2H6z"
  })), children);
})));
if (false) {}
const ServiceLevels = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ServiceLevels({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "19",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "11",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "19",
    r: "1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "14",
    r: "1"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m30,20h-2c0-1.2616-.1946-2.5042-.5786-3.6929l1.9033-.6146c.448,1.3876.6753,2.8369.6753,4.3075Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m29.8508,8.9775l-2.4368,2.4365-.0005-.0005c-.3621.3623-.8621.5864-1.4136.5864-1.103,0-2-.897-2-2,0-.5518.2241-1.0518.5864-1.4136l-.0005-.0005,2.4368-2.4365c-.3284-.0879-.667-.1494-1.0227-.1494-2.2056,0-4,1.7944-4,4,0,.7393.2153,1.4238.5669,2.019l-4.5479,4.5479c-.595-.3516-1.2795-.5669-2.019-.5669-2.2056,0-4,1.7944-4,4s1.7944,4,4,4,4-1.7944,4-4c0-.7397-.2153-1.4243-.5669-2.019l4.5479-4.5479c.595.3516,1.2795.5669,2.019.5669,2.2056,0,4-1.7944,4-4,0-.3555-.0615-.6943-.1492-1.0225Zm-13.8508,13.0225c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m4,20h-2c0-7.7196,6.2803-14,14-14,1.4707,0,2.9199.2272,4.3074.6754l-.6147,1.9031c-1.1885-.3838-2.4309-.5785-3.6926-.5785-6.6167,0-12,5.3832-12,12Z"
  })), children);
})));
if (false) {}
const SessionBorderControl = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SessionBorderControl({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M26,8,24.59,9.41,27.17,12H16a5.967,5.967,0,0,0-4,1.54V6.83l2.59,2.58L16,8,11,3,6,8,7.41,9.41,10,6.83V18a5.969,5.969,0,0,0,1.54,4H4.83l2.58-2.59L6,18,1,23l5,5,1.41-1.41L4.83,24H16A5.99,5.99,0,0,0,20.46,14h6.71l-2.58,2.59L26,18l5-5ZM20,18a4,4,0,1,1-4-4A4.0045,4.0045,0,0,1,20,18Z"
  })), children);
})));
if (false) {}
const Settings = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Settings({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
      d: "M13.5,8.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l1-0.8c0.4-0.3,0.4-0.9,0.2-1.3l-1.2-2C13.3,3.2,13,3,12.6,3 c-0.1,0-0.2,0-0.3,0.1l-1.2,0.4c-0.2-0.1-0.4-0.3-0.7-0.4l-0.3-1.3C10.1,1.3,9.7,1,9.2,1H6.8c-0.5,0-0.9,0.3-1,0.8L5.6,3.1 C5.3,3.2,5.1,3.3,4.9,3.4L3.7,3C3.6,3,3.5,3,3.4,3C3,3,2.7,3.2,2.5,3.5l-1.2,2C1.1,5.9,1.2,6.4,1.6,6.8l0.9,0.9c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.3,0,0.4L1.6,9.2c-0.4,0.3-0.5,0.9-0.2,1.3l1.2,2C2.7,12.8,3,13,3.4,13c0.1,0,0.2,0,0.3-0.1l1.2-0.4 c0.2,0.1,0.4,0.3,0.7,0.4l0.3,1.3c0.1,0.5,0.5,0.8,1,0.8h2.4c0.5,0,0.9-0.3,1-0.8l0.3-1.3c0.2-0.1,0.4-0.2,0.7-0.4l1.2,0.4 c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.5l1.1-2c0.2-0.4,0.2-0.9-0.2-1.3L13.5,8.4z M12.6,12l-1.7-0.6c-0.4,0.3-0.9,0.6-1.4,0.8 L9.2,14H6.8l-0.4-1.8c-0.5-0.2-0.9-0.5-1.4-0.8L3.4,12l-1.2-2l1.4-1.2c-0.1-0.5-0.1-1.1,0-1.6L2.2,6l1.2-2l1.7,0.6 C5.5,4.2,6,4,6.5,3.8L6.8,2h2.4l0.4,1.8c0.5,0.2,0.9,0.5,1.4,0.8L12.6,4l1.2,2l-1.4,1.2c0.1,0.5,0.1,1.1,0,1.6l1.4,1.2L12.6,12z"
    })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
      d: "M8,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3C11,9.6,9.7,11,8,11C8,11,8,11,8,11z M8,6C6.9,6,6,6.8,6,7.9C6,7.9,6,8,6,8 c0,1.1,0.8,2,1.9,2c0,0,0.1,0,0.1,0c1.1,0,2-0.8,2-1.9c0,0,0-0.1,0-0.1C10,6.9,9.2,6,8,6C8.1,6,8,6,8,6z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
  })), children);
})));
if (false) {}
const SettingsAdjust = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SettingsAdjust({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8h-4.1c-0.5-2.3-2.5-4-4.9-4s-4.4,1.7-4.9,4H2v2h14.1c0.5,2.3,2.5,4,4.9,4s4.4-1.7,4.9-4H30V8z M21,12c-1.7,0-3-1.3-3-3 s1.3-3,3-3s3,1.3,3,3S22.7,12,21,12z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M2,24h4.1c0.5,2.3,2.5,4,4.9,4s4.4-1.7,4.9-4H30v-2H15.9c-0.5-2.3-2.5-4-4.9-4s-4.4,1.7-4.9,4H2V24z M11,20c1.7,0,3,1.3,3,3 s-1.3,3-3,3s-3-1.3-3-3S9.3,20,11,20z"
  })), children);
})));
if (false) {}
const SettingsCheck = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SettingsCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A5.9364,5.9364,0,0,1,16,22Zm0-10a3.9123,3.9123,0,0,0-4,4,3.9123,3.9123,0,0,0,4,4,3.9123,3.9123,0,0,0,4-4A3.9123,3.9123,0,0,0,16,12Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3047,11.044,26.9441,6.9562a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583L20.3215,3.608A2,2,0,0,0,18.36,2H13.64A2,2,0,0,0,11.6785,3.608l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0616a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.044a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4947,5,15.7447,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025L5.0559,25.044a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713L6.7878,24.044l-2.36-4.0878,2.7253-2.3951a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.044,6.7886,7.9562l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.044Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26.18 20.41 23.59 19 25 23 29 30 22 28.59 20.59 23 26.18z"
  })), children);
})));
if (false) {}
const SettingsEdit = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SettingsEdit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m31.707,19.2929l-3-3c-.3906-.3906-1.0234-.3906-1.4141,0l-9.293,9.293v4.4141h4.4141l9.293-9.293c.3906-.3906.3906-1.0234,0-1.4141Zm-10.1211,8.707h-1.5859v-1.5859l5-5,1.5859,1.5859-5,5Zm6.4141-6.4141l-1.5859-1.5859,1.5859-1.5859,1.5859,1.5859-1.5859,1.5859Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m16,22c-3.3643,0-6-2.6357-6-6s2.6357-6,6-6,6,2.6357,6,6-2.6357,6-6,6Zm0-10c-2.2803,0-4,1.7197-4,4s1.7197,4,4,4,4-1.7197,4-4-1.7197-4-4-4Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m27.5474,12.0005l1.7322-1-2.3354-4.0444c-.3652-.6328-1.0334-1.0005-1.7322-1.0005-.2134,0-.4294.0342-.6406.106l-2.4341.8232c-.418-.2812-.856-.5352-1.312-.7583l-.5037-2.5186c-.187-.9351-1.0078-1.6079-1.9612-1.6079h-4.7207c-.9534,0-1.7742.6729-1.9612,1.6079l-.5037,2.5186c-.459.2246-.9062.4692-1.3267.7534l-2.4194-.8184c-.2112-.0718-.4272-.106-.6406-.106-.6987,0-1.3669.3677-1.7322,1.0005l-2.3606,4.0879c-.4766.8257-.3042,1.873.4119,2.5024l1.9309,1.6968c-.0171.2515-.0381.5015-.0381.7568,0,.2578.0103.5127.0278.7656l-1.9207,1.688c-.7161.6294-.8884,1.6768-.4119,2.5024l2.3606,4.0879c.3652.6328,1.0334,1.0005,1.7322,1.0005.2134,0,.4297-.0342.6406-.106l2.4341-.8232c.418.2817.856.5352,1.312.7583l.5037,2.5186c.187.9351,1.0078,1.6079,1.9612,1.6079h2.3604v-2h-2.3604l-.7102-3.5508c-.9753-.356-1.9026-.9062-2.6948-1.5713l-3.4468,1.166-2.3604-4.0879,2.7253-2.395c-.1838-1.043-.1914-2.083-.0071-3.1279l-2.7183-2.3892,2.3611-4.0879,3.4268,1.1592c.8032-.6763,1.7295-1.2051,2.7141-1.5645l.7102-3.5508h4.7207l.7102,3.5508c.9753.356,1.9023.9062,2.6948,1.5713l3.4468-1.166,2.3352,4.0444Z"
  })), children);
})));
if (false) {}
const SettingsServices = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SettingsServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M29,25H27V23h1V19H24v1H22V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,29,25Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H18a1,1,0,0,1-1-1V23a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,24,30Zm-5-2h4V24H19Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M15,19.8579A3.9934,3.9934,0,1,1,20,16h2a6,6,0,1,0-7,5.91Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28.89,13.55l-2.31,2.03-1.42-1.42,2.41-2.12L25.21,7.96,21.77,9.12a9.3684,9.3684,0,0,0-2.7-1.57L18.36,4H13.64l-.71,3.55a8.8609,8.8609,0,0,0-2.71,1.57L6.79,7.96,4.43,12.04l2.72,2.39a8.8948,8.8948,0,0,0,0,3.13l-2.72,2.4,2.36,4.08,3.44-1.16a9.3684,9.3684,0,0,0,2.7,1.57L13.64,28H15v2H13.64a2.0007,2.0007,0,0,1-1.96-1.61l-.51-2.52a11.412,11.412,0,0,1-1.31-.75l-2.43.82a2.038,2.038,0,0,1-.64.1,1.973,1.973,0,0,1-1.73-1L2.7,20.96a2,2,0,0,1,.41-2.51l1.92-1.68C5.01,16.51,5,16.26,5,16s.02-.51.04-.76L3.11,13.55a2,2,0,0,1-.41-2.51L5.06,6.96a1.973,1.973,0,0,1,1.73-1,2.038,2.038,0,0,1,.64.1l2.42.82a11.5416,11.5416,0,0,1,1.32-.75l.51-2.52A2.0007,2.0007,0,0,1,13.64,2h4.72a2.0007,2.0007,0,0,1,1.96,1.61l.51,2.52a11.412,11.412,0,0,1,1.31.75l2.43-.82a2.038,2.038,0,0,1,.64-.1,1.973,1.973,0,0,1,1.73,1l2.36,4.08A2,2,0,0,1,28.89,13.55Z"
  })), children);
})));
if (false) {}
const SettingsView = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SettingsView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "24",
    r: "2"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7769,23.4785A8.64,8.64,0,0,0,23,18a8.64,8.64,0,0,0-7.7769,5.4785L15,24l.2231.5215A8.64,8.64,0,0,0,23,30a8.64,8.64,0,0,0,7.7769-5.4785L31,24ZM23,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,23,28Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3989,20.8A6,6,0,1,1,22,16H20a4,4,0,1,0-6.4,3.2Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H15V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
  })), children);
})));
if (false) {}
const Shadow = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Shadow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M19,5c-1.0234,0-2.0312.1479-3.0046.4253-.9539-.2708-1.9561-.4253-2.9954-.4253-6.0654,0-11,4.9346-11,11s4.9346,11,11,11c1.0393,0,2.0415-.1545,2.9954-.4253.9734.2773,1.9812.4253,3.0046.4253,6.0654,0,11-4.9346,11-11s-4.9346-11-11-11ZM23.9495,16.9965l3.9866.0355c-.1228,1.0701-.4373,2.0808-.903,3.0039l-3.7977-.0342c.3713-.9463.6191-1.9531.7141-3.0052ZM23.9492,14.9963c-.0955-1.049-.343-2.0525-.7131-2.9963l3.8325.0378c.4548.9221.7627,1.9283.8772,2.994l-3.9966-.0355ZM25.7112,10.0244l-3.5099-.0347c-.7626-1.1636-1.7395-2.1714-2.8744-2.9731,2.536.0917,4.803,1.2339,6.3843,3.0078ZM4,16c0-4.9624,4.0371-9,9-9s9,4.0376,9,9-4.0371,9-9,9-9-4.0376-9-9ZM19.3269,24.9834c1.1405-.8057,2.121-1.8199,2.8853-2.9907l3.4556.031c-1.5793,1.7465-3.8279,2.8689-6.3408,2.9597h-.0001Z"
  })), children);
})));
if (false) {}
const ShapeExcept = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShapeExcept({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,20V12h8v8ZM3.9988,4H20v6H12a2.0023,2.0023,0,0,0-2,2v8H4Z"
  })), children);
})));
if (false) {}
const ShapeExclude = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShapeExclude({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6V12A2,2,0,0,1,12,10Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V20a2,2,0,0,1-2,2H10v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
  })), children);
})));
if (false) {}
const ShapeIntersect = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShapeIntersect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4H20v6H12a2.0025,2.0025,0,0,0-2,2v8Zm8,8V22h8a2.0025,2.0025,0,0,0,2-2V12h6V28Z"
  })), children);
})));
if (false) {}
const ShapeJoin = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShapeJoin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4h6V20Zm18,8V12h6V28Z"
  })), children);
})));
if (false) {}
const ShapeUnite = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShapeUnite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
  })), children);
})));
if (false) {}
const Shapes = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Shapes({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m5,16h-2v11c0,1.1045.8954,2,2,2h8v-2H5v-11Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,29h-11c-.3535,0-.6809-.1866-.8608-.4911-.0927-.1568-.1392-.3328-.1392-.5089,0-.1658.0412-.3317.1238-.4819l5.5-10c.1898-.3451.5333-.5178.8762-.5181.3434-.0003.6861.1724.8762.5181l5.5,10c.0826.1502.1238.3162.1238.4819,0,.1762-.0465.3521-.1392.5089-.1799.3044-.5073.4911-.8608.4911Zm-9.3088-2h7.6177l-3.8088-6.9249-3.8088,6.9249Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,3h-11v2h11v13.9922h2V5c0-1.1045-.8954-2-2-2Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m11,3h-6c-1.1046,0-2,.8955-2,2v6c0,1.1045.8954,2,2,2h6c1.1046,0,2-.8955,2-2v-6c0-1.1045-.8954-2-2-2Zm0,8h-6v-6h6v6Z"
  })), children);
})));
if (false) {}
const Share = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Share({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
  })), children);
})));
if (false) {}
const ShareKnowledge = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShareKnowledge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M27,25H21a3,3,0,0,0-3,3v2h2V28a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V28A3,3,0,0,0,27,25Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20a4,4,0,1,0,4-4A4,4,0,0,0,20,20Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,26,20Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M6,21V20H4v1a7,7,0,0,0,7,7h3V26H11A5,5,0,0,1,6,21Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6H29V8H19z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H29V4H19z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11H5a3,3,0,0,0-3,3v2H4V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V14A3,3,0,0,0,11,11Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10A4,4,0,1,0,4,6,4,4,0,0,0,8,10ZM8,4A2,2,0,1,1,6,6,2,2,0,0,1,8,4Z"
  })), children);
})));
if (false) {}
const ShoppingBag = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShoppingBag({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
  })), children);
})));
if (false) {}
const ShoppingCart = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShoppingCart({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
  })), children);
})));
if (false) {}
const ShoppingCartArrowDown = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShoppingCartArrowDown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M21.586 6.586 18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586z"
  })), children);
})));
if (false) {}
const ShoppingCartArrowUp = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShoppingCartArrowUp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M21.586 9.414 18 5.828 18 14 16 14 16 5.828 12.414 9.414 11 8 17 2 23 8 21.586 9.414z"
  })), children);
})));
if (false) {}
const ShoppingCartClear = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShoppingCartClear({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M18.41 8 22 4.41 20.59 3 17 6.59 13.41 3 12 4.41 15.59 8 12 11.59 13.41 13 17 9.41 20.59 13 22 11.59 18.41 8z"
  })), children);
})));
if (false) {}
const ShoppingCartError = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShoppingCartError({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M17,2a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,17,2Zm0,2a3.9521,3.9521,0,0,1,2.019.5669L13.5669,10.019A3.9529,3.9529,0,0,1,13,8,4.0045,4.0045,0,0,1,17,4Zm0,8a3.9521,3.9521,0,0,1-2.019-.5669L20.4331,5.981A3.9529,3.9529,0,0,1,21,8,4.0045,4.0045,0,0,1,17,12Z"
  })), children);
})));
if (false) {}
const ShoppingCartMinus = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShoppingCartMinus({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6 12 8 22 8 22 6 12 6z"
  })), children);
})));
if (false) {}
const ShoppingCartPlus = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShoppingCartPlus({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6 18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6z"
  })), children);
})));
if (false) {}
const ShoppingCatalog = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShoppingCatalog({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H21V28H17z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H28V28H24z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H21V21H17z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H28V21H24z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2 H6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
  })), children);
})));
if (false) {}
const ShowDataCards = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShowDataCards({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H4A2.0022,2.0022,0,0,1,2,8V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V8A2.0022,2.0022,0,0,1,28,10ZM4,4V8H28V4Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0022,2.0022,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v4A2.0022,2.0022,0,0,1,28,30ZM4,24v4H28V24Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H4a2.0022,2.0022,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v4A2.0022,2.0022,0,0,1,28,20ZM4,14v4H28V14Z"
  })), children);
})));
if (false) {}
const ShrinkScreen = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShrinkScreen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H17a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2H28a2.0027,2.0027,0,0,1,2,2v6A2.0027,2.0027,0,0,1,28,28ZM17,20v6H28.002L28,20Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10 12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
  })), children);
})));
if (false) {}
const ShrinkScreenFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ShrinkScreenFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "10",
    x: "15",
    y: "18",
    rx: "2"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10 12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
  })), children);
})));
if (false) {}
const Shuffle = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Shuffle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
  })), children);
})));
if (false) {}
const Shuttle = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Shuttle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
  })), children);
})));
if (false) {}
const SidePanelClose = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SidePanelClose({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8 l3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"
  })), children);
})));
if (false) {}
const SidePanelCloseFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SidePanelCloseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,15H17.8l3.6-3.6L20,10l-6,6l6,6 l1.4-1.4L17.8,17H28v9H12V6h16V15z"
  })), children);
})));
if (false) {}
const SidePanelOpen = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SidePanelOpen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,26H12v-9h10.2 l-3.6,3.6L20,22l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
  })), children);
})));
if (false) {}
const SidePanelOpenFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SidePanelOpenFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,26H12v-9h10.2l-3.6,3.6L20,22 l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
  })), children);
})));
if (false) {}
const Sight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Sight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H12V14H10z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8V14H6z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H4V14H2z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19z"
  })), children);
})));
if (false) {}
const Sigma = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Sigma({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5 7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z"
  })), children);
})));
if (false) {}
const SignalStrength = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SignalStrength({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6H28V26H26z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H20V26H18z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H13V26H11z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20H6V26H4z"
  })), children);
})));
if (false) {}
const SimCard = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SimCard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M21,9H8a2.0023,2.0023,0,0,0-2,2V21a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V11A2.0023,2.0023,0,0,0,21,9Zm0,4H18V11h3Zm-3,2h3v2H18Zm-2-4V21H13V14a1,1,0,0,0-1-1H8V11Zm-5,6H8V15h3ZM8,19h3v2H8Zm10,2V19h3v2Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5317,27H4a2.0021,2.0021,0,0,1-2-2V7A2.0021,2.0021,0,0,1,4,5H28a2.0021,2.0021,0,0,1,2,2V19.6379a2.0044,2.0044,0,0,1-.4639,1.2808L25.0679,26.28A1.9944,1.9944,0,0,1,23.5317,27ZM4,7V25H23.5317L28,19.6379V7Z"
  })), children);
})));
if (false) {}
const SkillLevel = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkillLevel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V4h8Zm-6-2h4V6H24Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V12h8Zm-6-2h4V14H14Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H2V18h8ZM4,28H8V20H4Z"
  })), children);
})));
if (false) {}
const SkillLevelAdvanced = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkillLevelAdvanced({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V4h8Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V12h8Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H2V18h8Z"
  })), children);
})));
if (false) {}
const SkillLevelBasic = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkillLevelBasic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V4h8Zm-6-2h4V6H24Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V12h8Zm-6-2h4V14H14Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H2V18h8Z"
  })), children);
})));
if (false) {}
const SkillLevelIntermediate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkillLevelIntermediate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V4h8Zm-6-2h4V6H24Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V12h8Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H2V18h8Z"
  })), children);
})));
if (false) {}
const SkipBack = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipBack({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28a1,1,0,0,1-.5-.13l-19-11a1,1,0,0,1,0-1.74l19-11a1,1,0,0,1,1,0A1,1,0,0,1,28,5V27a1,1,0,0,1-1,1ZM10,16l16,9.27V6.73Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H4V28H2z"
  })), children);
})));
if (false) {}
const SkipBackFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipBackFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28a.9975.9975,0,0,1-.501-.1348l-19-11a1,1,0,0,1,0-1.73l19-11A1,1,0,0,1,28,5V27a1,1,0,0,1-1,1Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H4V28H2z"
  })), children);
})));
if (false) {}
const SkipBackOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipBackOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3006V12.7Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V22H9z",
    transform: "matrix(-1 0 0 -1 20 32)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const SkipBackOutlineFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipBackOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.301 22 12.699 16.059 16 22 19.301z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3005V12.7Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H10V22H8z",
    transform: "matrix(-1 0 0 -1 18 32)"
  })), children);
})));
if (false) {}
const SkipBackOutlineSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipBackOutlineSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V22H9z",
    transform: "matrix(-1 0 0 -1 20 32)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const SkipBackSolidFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipBackSolidFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H10V22H8z",
    transform: "matrix(-1 0 0 -1 18 32)"
  })), children);
})));
if (false) {}
const SkipForward = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipForward({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M5,28a1,1,0,0,1-1-1V5a1,1,0,0,1,.5-.87,1,1,0,0,1,1,0l19,11a1,1,0,0,1,0,1.74l-19,11A1,1,0,0,1,5,28ZM6,6.73V25.27L22,16Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H30V28H28z"
  })), children);
})));
if (false) {}
const SkipForwardFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipForwardFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H30V28H28z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M5,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.501-.8652l19,11a1,1,0,0,1,0,1.73l-19,11A.9975.9975,0,0,1,5,28Z"
  })), children);
})));
if (false) {}
const SkipForwardOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipForwardOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H23V22H21z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8742l9,5a1,1,0,0,1,0,1.7485l-9,5a1.0009,1.0009,0,0,1-.9931-.0125ZM10,12.7v6.6011L15.9409,16Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const SkipForwardOutlineFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipForwardOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.301 15.941 16 10 12.699 10 19.301z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22 10H24V22H22z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8743l9,5a1,1,0,0,1,0,1.7486l-9,5a1.0009,1.0009,0,0,1-.9931-.0125ZM10,12.7v6.601L15.9409,16Z"
  })), children);
})));
if (false) {}
const SkipForwardOutlineSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipForwardOutlineSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H23V22H21z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8742l9,5a1,1,0,0,1,0,1.7485l-9,5a1.0009,1.0009,0,0,1-.9931-.0125Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const SkipForwardSolidFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SkipForwardSolidFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22 10H24V22H22z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8743l9,5a1,1,0,0,1,0,1.7486l-9,5a1.0009,1.0009,0,0,1-.9931-.0125Z"
  })), children);
})));
if (false) {}
const Sleet = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Sleet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H8V26H6z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26H10V28H8z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28H12V30H10z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H12V26H10z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28H8V30H6z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,21,30Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22h8.8818L16.106,24.5527a1,1,0,1,0,1.7885.8946L19.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
})));
if (false) {}
const Slisor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Slisor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a1.0005,1.0005,0,0,1-.4473-.1055l-10-5,.8946-1.789L16,19.8821l9.5527-4.7766.8946,1.789-10,5A1.0005,1.0005,0,0,1,16,22Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16a1.0005,1.0005,0,0,1-.4473-.1055l-10-5a1,1,0,0,1,0-1.789l10-5a1.0008,1.0008,0,0,1,.8946,0l10,5a1,1,0,0,1,0,1.789l-10,5A1.0005,1.0005,0,0,1,16,16ZM8.2358,10,16,13.8821,23.7642,10,16,6.1179Z"
  })), children);
})));
if (false) {}
const Slm = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Slm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9 26.5 14 26 16 25.5 14 24 9 22 9 22 23 24 23 24 15 23.8 13 24.4 15 26 19.6 27.6 15 28.2 13 28 15 28 23 30 23 30 9z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21 14 9 12 9 12 23 20 23 20 21z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M8,23H2v-2h6v-4H4c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h6v2H4v4h4c1.1,0,2,0.9,2,2v4C10,22.1,9.1,23,8,23z"
  })), children);
})));
if (false) {}
const Smell = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Smell({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M22,15V10H20v7h2a3,3,0,0,1,0,6H21V21H19v2a3,3,0,0,1-6,0V21H11v2H10a3,3,0,0,1,0-6h2V9a3,3,0,0,1,3-3h1V4H15a5,5,0,0,0-5,5v6a5,5,0,0,0,0,10h1.42a5,5,0,0,0,9.16,0H22a5,5,0,0,0,0-10Z"
  })), children);
})));
if (false) {}
const Smoke = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Smoke({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M27.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762a6.9956,6.9956,0,0,0-1.2446-5.6668L23.2,5.6a1,1,0,1,1,1.6-1.2l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L27.8,26.4A1,1,0,0,1,27.001,28Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M22.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762a6.9956,6.9956,0,0,0-1.2446-5.6668L18.2,5.6a1,1,0,1,1,1.6-1.2l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L22.8,26.4A1,1,0,0,1,22.001,28Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M17.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762a6.9956,6.9956,0,0,0-1.2446-5.6668L13.2,5.6a1,1,0,1,1,1.6-1.2l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L17.8,26.4A1,1,0,0,1,17.001,28Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762A6.9956,6.9956,0,0,0,9.0142,6.6855L8.2,5.6A1,1,0,1,1,9.8,4.4l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L12.8,26.4A1,1,0,0,1,12.001,28Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M7.001,28A.998.998,0,0,1,6.2,27.6l-.8145-1.086a8.9976,8.9976,0,0,1-1.6-7.2856l1.4736-6.8762A6.9956,6.9956,0,0,0,4.0142,6.6855L3.2,5.6A1,1,0,1,1,4.8,4.4l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856L5.7412,19.6474a6.9956,6.9956,0,0,0,1.2446,5.6668L7.8,26.4A1,1,0,0,1,7.001,28Z"
  })), children);
})));
if (false) {}
const WatsonHealthSmoothing = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthSmoothing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "5"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7,4.7a14.7029,14.7029,0,0,0-3,3.1L6.3,9A13.2634,13.2634,0,0,1,8.9,6.3Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6,12.3l-1.9-.6A12.5111,12.5111,0,0,0,2,16H4A11.4756,11.4756,0,0,1,4.6,12.3Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7,20.4a14.4029,14.4029,0,0,0,2,3.9l1.6-1.2a12.8867,12.8867,0,0,1-1.7-3.3Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8,27.3a14.4029,14.4029,0,0,0,3.9,2l.6-1.9A12.8867,12.8867,0,0,1,9,25.7Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7,2.7l.6,1.9A11.4756,11.4756,0,0,1,16,4V2A12.5111,12.5111,0,0,0,11.7,2.7Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2,27.3a15.18,15.18,0,0,0,3.1-3.1L25.7,23A11.526,11.526,0,0,1,23,25.7Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4,19.7l1.9.6A15.4747,15.4747,0,0,0,30,16H28A11.4756,11.4756,0,0,1,27.4,19.7Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2,11.6a14.4029,14.4029,0,0,0-2-3.9L25.6,8.9a12.8867,12.8867,0,0,1,1.7,3.3Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1,4.6a14.4029,14.4029,0,0,0-3.9-2l-.6,1.9a12.8867,12.8867,0,0,1,3.3,1.7Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,29.3l-.6-1.9A11.4756,11.4756,0,0,1,16,28v2A21.4206,21.4206,0,0,0,20.3,29.3Z"
  })), children);
})));
if (false) {}
const WatsonHealthSmoothingCursor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthSmoothingCursor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "4"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a11.8932,11.8932,0,0,1-4.1035-.72L14.58,27.4A9.9725,9.9725,0,0,0,18,28Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1484,29.2637l-.6914-1.877a9.9556,9.9556,0,0,0,2.9973-1.748l1.2916,1.5268A11.9525,11.9525,0,0,1,22.1484,29.2637Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2893,27.1951A12.0141,12.0141,0,0,1,7.61,24.0078l1.73-1.0029a10.0236,10.0236,0,0,0,2.2347,2.6584Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4133,23.967l-1.7343-.9956a9.9159,9.9159,0,0,0,1.176-3.2641l1.9712.3388A11.8956,11.8956,0,0,1,28.4133,23.967Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1821,20.0925A12.1282,12.1282,0,0,1,6.1777,15.93l1.9707.3423a10.1214,10.1214,0,0,0,.0035,3.4738Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8447,16.2339a9.9019,9.9019,0,0,0-1.1953-3.2564l1.7285-1.0063a11.9029,11.9029,0,0,1,1.4361,3.9121Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3313,13.0107l-1.7324-.999a12.01,12.01,0,0,1,2.6738-3.1931l1.2886,1.53A10.01,10.01,0,0,0,9.3313,13.0107Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4094,10.3237a9.96,9.96,0,0,0-3.0088-1.7309l.68-1.8809a11.9491,11.9491,0,0,1,3.6118,2.0772Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M14.562,8.6064l-.6875-1.8779A12.1031,12.1031,0,0,1,18,6V8A10.0875,10.0875,0,0,0,14.562,8.6064Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2 2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
})));
if (false) {}
const Snooze = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Snooze({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14 20 12 12 12 12 14 17.5 14 12 20 12 22 20 22 20 20 14.507 20 20 14z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3.965H26.499V9.036999999999999H24.5z",
    transform: "rotate(-44.945 25.5 6.5)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11.0125,11.0125,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,8Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M3.965 5.501H9.036999999999999V7.5H3.965z",
    transform: "rotate(-45.055 6.5 6.5)"
  })), children);
})));
if (false) {}
const Snow = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Snow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22ZM16,4a7,7,0,0,0-6.94,6.14L9,11,8.14,11a4.5,4.5,0,0,0,.36,9h15a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82A7,7,0,0,0,16,4Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M12 25.05 10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25.05 24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27.05 17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
  })), children);
})));
if (false) {}
const SnowBlizzard = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SnowBlizzard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H15V12H13z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V14H15z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14H19V16H17z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H19V12H17z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14H15V16H13z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M3 26H5V28H3z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28H7V30H5z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30H9V32H7z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26H9V28H7z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M3 30H5V32H3z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H25V28H23z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28H27V30H25z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30H29V32H27z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26H29V28H27z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30H25V32H23z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H10V20H8z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H12V22H10z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22H14V24H12z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H14V20H12z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H10V24H8z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H20V20H18z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V22H20z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H24V24H22z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18H24V20H22z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26H15V28H13z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28H17V30H15z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30H19V32H17z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26H19V28H17z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30H15V32H13z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
  })), children);
})));
if (false) {}
const SnowHeavy = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SnowHeavy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H6V28H4z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28H8V30H6z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H10V32H8z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26H10V28H8z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30H6V32H4z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H10V20H8z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H12V22H10z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22H14V24H12z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H14V20H12z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H10V24H8z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H20V20H18z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V22H20z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H24V24H22z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18H24V20H22z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H16V28H14z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H18V30H16z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30H20V32H18z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H20V28H18z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30H16V32H14z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
  })), children);
})));
if (false) {}
const SnowScattered = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SnowScattered({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H4V28H2z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H6V30H4z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30H8V32H6z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26H8V28H6z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M2 30H4V32H2z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H22V28H20z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H24V30H22z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30H26V32H24z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30H22V32H20z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M11 26H13V28H11z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H15V30H13z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30H17V32H15z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V28H15z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30H13V32H11z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10.001H32V12.001H29z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 16.233H29.732V18.233H26.732z",
    transform: "rotate(225 28.232 17.233)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M12.268 3.768H15.268V5.768H12.268z",
    transform: "rotate(225 13.768 4.768)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9852,5.9852,0,0,0,16.1431,7.5083,7.3737,7.3737,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a5.9672,5.9672,0,0,0,5.5667-8.2A5.9722,5.9722,0,0,0,27,11ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm4.5222-7.9131a5.9592,5.9592,0,0,0-2.8728-1.8428,7.5212,7.5212,0,0,0-2.7224-3.78,3.9869,3.9869,0,1,1,5.5952,5.6225Z"
  })), children);
})));
if (false) {}
const SnowScatteredNight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SnowScatteredNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H4V28H2z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H6V30H4z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30H8V32H6z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26H8V28H6z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M2 30H4V32H2z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H22V28H20z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H24V30H22z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30H26V32H24z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30H22V32H20z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M11 26H13V28H11z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H15V30H13z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30H17V32H15z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V28H15z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30H13V32H11z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8439,13.0347a1.517,1.517,0,0,0-1.23-.8658,5.3552,5.3552,0,0,1-3.4095-1.7158,6.4655,6.4655,0,0,1-1.286-6.3926,1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.7685,7.7685,0,0,0-5.8847,5.5737A7.3706,7.3706,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a6.0066,6.0066,0,0,0,6-6c0-.0571-.0123-.1113-.0139-.1685a7.5076,7.5076,0,0,0,4.7611-3.2768A1.5369,1.5369,0,0,0,29.8439,13.0347ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm5.5974-6.1289a5.9661,5.9661,0,0,0-3.948-3.627,7.49,7.49,0,0,0-2.489-3.58,5.9018,5.9018,0,0,1,3.6381-4.4473,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,14.041,5.4487,5.4487,0,0,1,24.5974,15.8711Z"
  })), children);
})));
if (false) {}
const SnowDensity = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SnowDensity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 16.8 19.4 15.2 17 17 17 14 15 14 15 17 12.6 15.2 11.4 16.8 14.333 19 11.4 21.2 12.6 22.8 15 21 15 24 17 24 17 21 19.4 22.8 20.6 21.2 17.667 19 20.6 16.8z"
  })), children);
})));
if (false) {}
const Snowflake = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Snowflake({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4148,12H28V10H23.4148l4.5857-4.5854L26.5864,4,22,8.5869V4H20v6.5869L18.5867,12H17V8H15v4H13.4133L12,10.5869V4H10V8.5869L5.4136,4,4,5.4146,8.5852,10H4v2h6.5852L12,13.415V15H8v2h4v1.5869L10.5867,20H4v2H8.5867L4,26.5864l1.4141,1.4141L10,23.415V28h2V21.415L13.4148,20H15v4h2V20h1.5852L20,21.415V28h2V23.415l4.5854,4.5855L28,26.5864,23.4133,22H28V20H21.4133L20,18.5869V17h4V15H20V13.415ZM18,18H14V14h4Z"
  })), children);
})));
if (false) {}
const Soccer = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Soccer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "28",
    r: "2"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 17.5H15.45V19.5H7.55z",
    transform: "rotate(-45 11.5 18.5)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16.584,19.4143,8H6v2H18.5857l3,3L6,28.5859,7.4141,30,23,14.415,26.584,18,23,21.5859,24.4141,23,28,19.416A2.0044,2.0044,0,0,0,28,16.584Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,9A3.5,3.5,0,1,1,28,5.5,3.504,3.504,0,0,1,24.5,9Zm0-5A1.5,1.5,0,1,0,26,5.5,1.5017,1.5017,0,0,0,24.5,4Z"
  })), children);
})));
if (false) {}
const SoftwareResource = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SoftwareResource({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), children);
})));
if (false) {}
const SoftwareResourceCluster = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SoftwareResourceCluster({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M24,21c-0.5,0-1-0.2-1.4-0.6l-3-3C19.2,17,19,16.5,19,16s0.2-1,0.6-1.4l3-3C23,11.2,23.5,11,24,11c0.5,0,1,0.2,1.4,0.6l3,3 C28.8,15,29,15.5,29,16c0,0.5-0.2,1-0.6,1.4l-3,3C25,20.8,24.5,21,24,21z M24,13l-3,3l3,3l3-3L24,13z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13c-0.5,0-1-0.2-1.4-0.6l-3-3C11.2,9,11,8.5,11,8s0.2-1,0.6-1.4l3-3C15,3.2,15.5,3,16,3c0.5,0,1,0.2,1.4,0.6l3,3 C20.8,7,21,7.5,21,8c0,0.5-0.2,1-0.6,1.4l-3,3C17,12.8,16.5,13,16,13z M16,5l-3,3l3,3l3-3L16,5z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M16,29c-0.5,0-1-0.2-1.4-0.6l-3-3C11.2,25,11,24.5,11,24s0.2-1,0.6-1.4l3-3C15,19.2,15.5,19,16,19c0.5,0,1,0.2,1.4,0.6l3,3 C20.8,23,21,23.5,21,24c0,0.5-0.2,1-0.6,1.4l-3,3C17,28.8,16.5,29,16,29z M16,21l-3,3l3,3l3-3L16,21z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M8,21c-0.5,0-1-0.2-1.4-0.6l-3-3C3.2,17,3,16.5,3,16s0.2-1,0.6-1.4l3-3C7,11.2,7.5,11,8,11c0.5,0,1,0.2,1.4,0.6l3,3 C12.8,15,13,15.5,13,16c0,0.5-0.2,1-0.6,1.4l-3,3C9,20.8,8.5,21,8,21z M8,13l-3,3l3,3l3-3L8,13z"
  })), children);
})));
if (false) {}
const SoftwareResourceResource = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SoftwareResourceResource({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 8.3H11.7V10.3H6.9z",
    transform: "rotate(-45 9.293 9.293)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9,19.7l-2.3-2.3C2.2,17,2,16.5,2,16s0.2-1,0.6-1.4l2.3-2.3l1.4,1.4L4,16l2.3,2.3L4.9,19.7z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 20.3H10.3V25.1H8.3z",
    transform: "rotate(-45 9.293 22.707)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-0.5,0-1-0.2-1.4-0.6l-2.3-2.3l1.4-1.4L16,28l2.3-2.3l1.4,1.4l-2.3,2.3C17,29.8,16.5,30,16,30z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 21.7H25.1V23.7H20.3z",
    transform: "rotate(-45 22.707 22.707)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1,19.7l-1.4-1.4L28,16l-2.3-2.3l1.4-1.4l2.3,2.3C29.8,15,30,15.5,30,16s-0.2,1-0.6,1.4L27.1,19.7z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 6.9H23.7V11.7H21.7z",
    transform: "rotate(-45 22.707 9.293)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2c-0.5,0-1,0.2-1.4,0.6l-2.3,2.3l1.4,1.4L16,4l2.3,2.3l1.4-1.4l-2.3-2.3C17,2.2,16.5,2,16,2z"
  })), children);
})));
if (false) {}
const SoilMoisture = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SoilMoisture({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,28A5.385,5.385,0,0,1,19,22.751a5.3837,5.3837,0,0,1,.874-2.8308L23.49,14.5383a1.217,1.217,0,0,1,2.02,0L29.06,19.8154A5.4923,5.4923,0,0,1,30,22.751,5.385,5.385,0,0,1,24.5,28Zm0-11.38-2.9356,4.3672A3.3586,3.3586,0,0,0,21,22.751a3.51,3.51,0,0,0,7,0,3.4356,3.4356,0,0,0-.63-1.867Z"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "13",
    r: "1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "19",
    r: "1"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "25",
    r: "1"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "15",
    r: "1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "11",
    r: "1"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "11",
    r: "1"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "21",
    r: "1"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H30V8H2z"
  })), children);
})));
if (false) {}
const SoilMoistureField = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SoilMoistureField({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,30a5.202,5.202,0,0,1-4.626-8.08L23.49,16.5382a1.217,1.217,0,0,1,2.02,0L29.06,21.8154A5.4921,5.4921,0,0,1,30,24.751,5.385,5.385,0,0,1,24.5,30Zm0-11.38-2.9356,4.3672A3.2079,3.2079,0,0,0,24.5,28,3.3855,3.3855,0,0,0,28,24.751a3.4354,3.4354,0,0,0-.63-1.867Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16V11h1a4.0045,4.0045,0,0,0,4-4V4H13a3.9779,3.9779,0,0,0-2.7468,1.1067A6.0034,6.0034,0,0,0,5,2H2V5a6.0066,6.0066,0,0,0,6,6H9v5H2v2H16V16ZM13,6h1V7a2.002,2.002,0,0,1-2,2H11V8A2.002,2.002,0,0,1,13,6ZM8,9A4.0045,4.0045,0,0,1,4,5V4H5A4.0045,4.0045,0,0,1,9,8V9Z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21H16V23H2z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H16V28H2z"
  })), children);
})));
if (false) {}
const SoilMoistureGlobal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SoilMoistureGlobal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30a4.7347,4.7347,0,0,1-4.2075-7.35l3.3687-5.1942a1,1,0,0,1,1.6779,0l3.3152,5.11A4.9753,4.9753,0,0,1,30,25.2231,4.8979,4.8979,0,0,1,25,30Zm0-10.1629-2.5078,3.8662A2.9264,2.9264,0,1,0,28,25.2231a2.96,2.96,0,0,0-.5444-1.6028Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24H14A12.0137,12.0137,0,0,1,26,12h4v2H26A10.0113,10.0113,0,0,0,16,24Z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
  })), children);
})));
if (false) {}
const SoilTemperature = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SoilTemperature({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "13",
    r: "1"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "19",
    r: "1"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "25",
    r: "1"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "15",
    r: "1"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "11",
    r: "1"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "21",
    r: "1"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30a4.9863,4.9863,0,0,1-3-8.98V15a3,3,0,0,1,6,0v6.02A4.9863,4.9863,0,0,1,25,30Zm0-16a1.0011,1.0011,0,0,0-1,1v7.13l-.4971.2893A2.9676,2.9676,0,0,0,22,25a3,3,0,0,0,6,0,2.9676,2.9676,0,0,0-1.5029-2.5811L26,22.13V15A1.0011,1.0011,0,0,0,25,14Z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H30V8H2z"
  })), children);
})));
if (false) {}
const SoilTemperatureField = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SoilTemperatureField({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16V11h1a4.0045,4.0045,0,0,0,4-4V4H13a3.9779,3.9779,0,0,0-2.7468,1.1067A6.0034,6.0034,0,0,0,5,2H2V5a6.0066,6.0066,0,0,0,6,6H9v5H2v2H16V16ZM13,6h1V7a2.002,2.002,0,0,1-2,2H11V8A2.002,2.002,0,0,1,13,6ZM8,9A4.0045,4.0045,0,0,1,4,5V4H5A4.0045,4.0045,0,0,1,9,8V9Z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21H16V23H2z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H16V28H2z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30a4.9863,4.9863,0,0,1-3-8.98V15a3,3,0,0,1,6,0v6.02A4.9863,4.9863,0,0,1,25,30Zm0-16a1.0011,1.0011,0,0,0-1,1v7.13l-.4971.2893A2.9676,2.9676,0,0,0,22,25a3,3,0,0,0,6,0,2.9676,2.9676,0,0,0-1.5029-2.5811L26,22.13V15A1.0011,1.0011,0,0,0,25,14Z"
  })), children);
})));
if (false) {}
const SoilTemperatureGlobal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SoilTemperatureGlobal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30a4.9863,4.9863,0,0,1-3-8.98V15a3,3,0,0,1,6,0v6.02A4.9863,4.9863,0,0,1,25,30Zm0-16a1.0011,1.0011,0,0,0-1,1v7.13l-.4971.2893A2.9676,2.9676,0,0,0,22,25a3,3,0,0,0,6,0,2.9676,2.9676,0,0,0-1.5029-2.5811L26,22.13V15A1.0011,1.0011,0,0,0,25,14Z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24H14a11.89,11.89,0,0,1,3.7642-8.7271l1.373,1.4542A9.909,9.909,0,0,0,16,24Z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
  })), children);
})));
if (false) {}
const SolarPanel = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SolarPanel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M30,26V14H13V26h5v2H2v2H30V28H25V26Zm-5-2V21h3v3Zm-2-3v3H20V21Zm-3-2V16h3v3Zm8,0H25V16h3ZM18,16v3H15V16Zm-3,8V21h3v3Zm8,4H20V26h3Z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3328,14.981A4,4,0,1,1,16,12H14a2,2,0,1,0-3.3333,1.4907Z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H13V6H11z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11H6V13H2z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M5.343 4.343H7.343V8.343H5.343z",
    transform: "rotate(-45 6.343 6.343)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M16.657 4.343H18.657V8.343H16.657z",
    transform: "rotate(225 17.657 6.343)"
  })), children);
})));
if (false) {}
const SortAscending = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SortAscending({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22 19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H16V20H2z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H16V14H6z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H16V8H10z"
  })), children);
})));
if (false) {}
const SortDescending = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SortDescending({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22 19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H16V8H2z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H16V14H6z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H16V20H10z"
  })), children);
})));
if (false) {}
const SortRemove = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SortRemove({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.415 28.586 18 25 21.587 21.414 18 20 19.415 23.586 23 20 26.586 21.414 28 25 24.414 28.586 28 30 26.586 26.414 23 30 19.415z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H16V20H10z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H16V8H2z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H16V14H6z"
  })), children);
})));
if (false) {}
const SortingAToZ = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SortingAToZ({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M11,13c0-1.103-.8975-2-2-2h-5v2h5v2h-4c-1.1046,0-2,.8954-2,2v2c0,1.1046.8954,2,2,2h6v-8ZM9,19h-4v-2h4v2ZM16,2l-5,6h10l-5-6ZM16,30l5-6h-10l5,6ZM29,11h-8v2h5.5l-5.5,6v2h8v-2h-5.4927l5.4927-6v-2ZM19,17v-2h-6v2h6Z"
  })), children);
})));
if (false) {}
const SortingHighestToLowestNumber = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SortingHighestToLowestNumber({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9756,2l-5,6h10l-5-6ZM15.9756,30l5-6h-10l5,6ZM24.9756,19v-8h-2v1h-2v2h2v5h-2v2h6v-2h-2ZM10.9756,19h-4v-2h2c1.1025,0,2-.897,2-2v-2c0-1.103-.8975-2-2-2h-4v2h4v2h-2c-1.103,0-2,.897-2,2v4h6v-2ZM18.9756,17v-2h-6v2h6Z"
  })), children);
})));
if (false) {}
const SortingLowestToHighestNumber = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SortingLowestToHighestNumber({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9756,2l-5,6h10l-5-6ZM15.9756,30l5-6h-10l5,6ZM10.9756,19h-2v-8h-2v1h-2v2h2v5h-2v2h6v-2ZM24.9756,17c1.1025,0,2-.897,2-2v-2c0-1.103-.8975-2-2-2h-4v2h4v2h-2c-1.103,0-2,.897-2,2v4h6v-2h-4v-2h2ZM18.9756,17v-2h-6v2h6Z"
  })), children);
})));
if (false) {}
const SortingZToA = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SortingZToA({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11h-5v2h5v2h-4c-1.1046,0-2,.8954-2,2v2c0,1.1046.8954,2,2,2h6v-8c0-1.103-.8975-2-2-2ZM27,19h-4v-2h4v2ZM16,2l-5,6h10l-5-6ZM16,30l5-6h-10l5,6ZM11,19h-5.4927l5.4927-6v-2H3v2h5.5l-5.5,6v2h8v-2ZM19,17v-2h-6v2h6Z"
  })), children);
})));
if (false) {}




/***/ }),

/***/ 2703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })

}]);